import { FC, useState, SyntheticEvent, ChangeEvent, useEffect, KeyboardEvent } from "react";
import Block from "../components/Block.component";
import DeviceConfig from "../config/Device.config";
import Device from "../interfaces/Device.interface";
import colors from "../config/Colors.config";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { styled } from '@mui/system';
import { FormControl, IconButton, InputLabel, Tabs } from "@mui/material";
import { Button, Card, CardBody, CardHeader, Col, DropdownItem, FormGroup, Input, InputGroup, InputGroupText, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import Cliente from "../interfaces/Cliente.interface";
import ClienteModel from "../models/Cliente.model";
import FechaTool from "../tools/Fecha.tool";
import Genero from "../interfaces/Genero.interface";
import GeneroService from "../services/Genero.service";
import Response from "../interfaces/Response.interface";
import PaisService from "../services/Pais.service";
import Pais from "../interfaces/Pais.interface";
import Estado from "../interfaces/Estado.interface";
import EstadoService from "../services/Estado.service";
import { Add, AttachMoneyOutlined, BadgeOutlined, Cached, CalendarTodayOutlined, Chat, Check, CheckBox, CheckBoxOutlineBlank, Close, CloseFullscreen, CreditCard, DeleteOutlineOutlined, Description, EditCalendarOutlined, ErrorOutlined, InfoOutlined, LocationOnOutlined, MyLocation, PaymentOutlined, PersonOutlineOutlined, PriceCheckOutlined, Save, SaveOutlined, Search, WarningAmberOutlined, Work, AutoDeleteOutlined, Groups2Outlined, RecommendOutlined, PostAddOutlined, DownloadOutlined } from "@mui/icons-material";
import Actividad from "../interfaces/Actividad.interface";
import ActividadService from "../services/Actividad.service";
import Table, { TableColumn } from 'react-data-table-component';
import ComponentsTool from "../tools/Components.tool";
import Ciudad from "../interfaces/Ciudad.interface";
import CiudadService from "../services/Ciudad.service";
import ColoniaService from "../services/Colonia.service";
import Colonia from "../interfaces/Colonia.interface";
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { Tooltip } from 'react-tooltip';
import Help from '@mui/icons-material/Help';
import Numero from "../tools/Numero.tool";
import Correo from "../tools/Correo.tool";
import SelectStyle from "../assets/styles/Select.style";
import Valor from "../interfaces/Valor.interface";
import OperacionesService from "../services/Operacion.service";
import ClienteService from "../services/Cliente.service";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useSearchParams } from "react-router-dom";
import DataTable from "react-data-table-component";
import SolicitudCredito from "../interfaces/SolicitudCredito.interface";
import SolicitudCreditoModel from "../models/SolicitudCredito.model";
import SolicitudCreditoService from "../services/SolicitudCredito.service";
import TiempoTool from "../tools/Tiempo.tool";
import Usuario from "../interfaces/Usuario.interface";
import { pdf, PDFViewer } from "@react-pdf/renderer";
import SolicitudCreditoPdf from "../reports/SolicitudCredito.report";

import icoNoDato from "../assets/icon/sin-perfil.png";
import iconSearch from "../assets/icon/iconSearch.png";
import imgMapa from "../assets/img/mapa.png";
import icoPDF from "../assets/icon/iconPdf.png";

let lastClickTime = 0;

type Browser = "Chrome" | "Brave" | "Opera" | "Edge" | "Firefox" | "Safari" | "";

interface Value { Id: number, value: string }

const ClienteAgregar: FC<{ usuario: Usuario }> = ({ usuario }) => {

    const navigate = useNavigate();

    const [searchParams] = useSearchParams();


    const [data] = useState<Device>(DeviceConfig.data());
    const MyTabs = styled(Tabs)(() => ({ '.MuiTabs-indicator': { backgroundColor: colors.primario, color: colors.primario }, }));

    const objectCliente: Cliente = ClienteModel.getEstructura();
    const objectSolicitud: SolicitudCredito = SolicitudCreditoModel.getEstructura();

    const [actividadTexto, setActividadTexto] = useState<string>("");

    const [cliente, setCliente] = useState<Cliente>(objectCliente);
    const [value, setValue] = useState<string>('1');

    const [generosLista, setGenerosLista] = useState<Genero[]>([]);
    const [paisesLista, setPaisesLista] = useState<Pais[]>([]);
    const [estadosNacimientoLista, setEstadosNacimientoLista] = useState<Estado[]>([]);
    const [estadosRecidenciaLista, setEstadosRecidenciaLista] = useState<Estado[]>([]);
    const [actividadLista, setActividadLista] = useState<Actividad[]>([]);
    const [ciudadesRecidenciaLista, setCiudadesRecidenciaLista] = useState<Ciudad[]>([]);
    const [coloniaLista, setColoniaLista] = useState<Colonia[]>([]);

    const [isOpenModalActividad, setIsOpenModalActividad] = useState<boolean>(false);
    const [isOpenModalError, setIsOpenModalError] = useState<boolean>(false);
    const [isOpenModalSolicitud, setIsOpenModalSolicitud] = useState<boolean>(false);
    const [isOpenModalEliniarSolicitud, setIsOpenModalEliniarSolicitud] = useState<boolean>(false);

    const [correoValida, setCorreoValido] = useState<boolean>(false);

    const [operacionesNumeros, setOperacionesNumeros] = useState<Valor[]>([]);
    const [operacionesMontos, setOperacionesMontos] = useState<Valor[]>([]);
    const [operacionesFrecuencias, setOperacionesFrecuencias] = useState<Valor[]>([]);

    const [arraySolicitudCredito, setArraysolicitudCredito] = useState<SolicitudCredito[]>([]);
    const [solicitudCredito, setSolicitudCredito] = useState<SolicitudCredito>(objectSolicitud);

    const [arrayTipo, setArrayTipo] = useState<Value[]>([]);
    const [arrayStatus, setArrayStatus] = useState<Value[]>([]);
    const [arrayMonto, setArrayMonto] = useState<Value[]>([]);
    const [arrayPlazo, setArrayPlazo] = useState<Value[]>([]);
    const [arrayFormaPago, setArrayFormaPago] = useState<Value[]>([]);

    const [isOpenModalSolicitudError, setIsOpenModalSolicitudError] = useState<boolean>(false);
    const [indexDatoFaltanteSolicitud, setIndexFaltanteSolicitud] = useState<{ index: string, value: boolean }[]>([]);

    const [isOpenModelPDF, setIsOpenModalPDF] = useState<boolean>(false);

    const handleChange = (event: SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };

    const cambioCliente = (name: string, value: string | number): void => {
        setCliente((prev: Cliente) => ({ ...prev, [name]: value }));
    }

    useEffect(() => {
        cargarDatos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const cargarCatalogoSolicitudCredito = async (): Promise<void> => {
        const response: Response = await SolicitudCreditoService.listarCatalogo();
        if (response.error === false) {
            const arrayTipo: Value[] = response.data.value.arraySolicitudCreditoTipo ?? [];
            const arrayStatus: Value[] = response.data.value.arraySolicitudCreditoStatus ?? [];
            const arrayMonto: Value[] = response.data.value.arraySolicitudCreditoMonto ?? [];
            const arrayPlazo: Value[] = response.data.value.arraySolicitudCreditoPlazo ?? [];
            const arrayFormaPago: Value[] = response.data.value.arraySolicitudCreditoFormaPago ?? [];
            setArrayTipo(arrayTipo);
            setArrayStatus(arrayStatus);
            setArrayMonto(arrayMonto);
            setArrayPlazo(arrayPlazo);
            setArrayFormaPago(arrayFormaPago);
        }
    };

    const cargarDatos = async (): Promise<void> => {
        await Promise.all([
            generosListar(),
            paisListar(),
            operacionesListar(),
            actividadesListar("")
        ]);

        await cargarURL();
    }

    const obtenerNombreNavegador = (): Browser => {
        const ua = navigator.userAgent;

        // Brave (tiene API especial)
        if ((navigator as any).brave && typeof (navigator as any).brave.isBrave === "function") {
            return "Brave";
        }

        if (ua.includes("OPR") || ua.includes("Opera")) {
            return "Opera";
        }

        if (ua.includes("Edg")) {
            return "Edge";
        }

        if (ua.includes("Chrome")) {
            return "Chrome";
        }

        if (ua.includes("Firefox")) {
            return "Firefox";
        }

        if (ua.includes("Safari") && !ua.includes("Chrome")) {
            return "Safari";
        }

        return "";
    };

    const obtenerUbicacion = async () => {
        try {
            const permiso = await navigator.permissions.query({
                name: "geolocation",
            } as PermissionDescriptor);

            if (permiso.state === "granted") {
                getLocation();
            }

            if (permiso.state === "prompt") {
                getLocation();
            }

            if (permiso.state === "denied") {
                alert("Debes habilitar la ubicación en el navegador");
            }

            // Detecta cambios (cuando el usuario acepta después)
            permiso.onchange = () => {
                if (permiso.state === "granted") {
                    getLocation();
                }
            };

        } catch (error) {
            console.error(error);
        }
    };

    const getLocation = () => {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                // const coords = {
                //     latitud: position.coords.latitude,
                //     longitud: position.coords.longitude,
                // };
                const latitud: string = position.coords.latitude.toString();
                const longitud: string = position.coords.longitude.toString();
                setCliente((prev: Cliente) => ({ ...prev, latitud, longitud }));
            },
            (err) => {
                console.error("Error obteniendo ubicación", err);
            }
        );
    };

    const solicitudCreditoListar = async (IdCliente: number): Promise<void> => {
        const response: Response = await SolicitudCreditoService.listar(IdCliente);
        if (response.data.error === false) {
            let arraySolicitudCredito: SolicitudCredito[] = response.data.value ?? [];
            setArraysolicitudCredito(arraySolicitudCredito);
        }
    };

    const solicitudCreditoEliminar = async (): Promise<void> => {
        await SolicitudCreditoService.eliminar(solicitudCredito.IdSolicitudCredito);
        solicitudCreditoListar(cliente.IdCliente);
        setIsOpenModalEliniarSolicitud(false);
        toast.info("Solicitud de Credito Eliminada");
    };

    const cargarURL = async (): Promise<void> => {
        const IdCliente: number = Number(searchParams.get("cliente")) ?? 0;
        if (IdCliente === 0) {
            setCliente(objectCliente);
        } else {
            const response: Response = await ClienteService.obtenerPorId(IdCliente);
            if (response.error === false) {
                let cliente: Cliente = response.data.value ?? [];
                cliente = { ...cliente, numeroTelefono: Numero.formatPhoneNumber(cliente.numeroTelefono) };
                setCliente(cliente);
                estadosNacimientoListar(cliente.paisNacimiento.IdPais);
                ciudadesRecidenciaListar(cliente.estadoNacimiento.IdEstado);
                estadosRecidenciaListar(cliente.paisRecidencia.IdPais);
                coloniaListar(cliente.ciudadRecidencia.IdCiudad);

                setCorreoValido(Correo.validar(cliente.correo));

                solicitudCreditoListar(cliente.IdCliente);
            }
        }
        navigate(`/dashboard/?page=${1}&cliente=${IdCliente}`);
    }

    const operacionesListar = async (): Promise<void> => {
        const response: Response = await OperacionesService.listar();
        if (response.error === false) {
            const operacionesNumeros: Valor[] = response.data.value.operacionesNumeros;
            const operacionesMontos: Valor[] = response.data.value.operacionesMontos;
            const operacionesFrecuencias: Valor[] = response.data.value.operacionesFrecuencias;
            setOperacionesNumeros(operacionesNumeros);
            setOperacionesMontos(operacionesMontos);
            setOperacionesFrecuencias(operacionesFrecuencias);
        }
    };

    const actividadesListar = async (texto: string): Promise<void> => {
        const response: Response = await ActividadService.listar(texto);
        if (response.error === false) {
            const actividadLista: Actividad[] = response.data.value;
            setActividadLista(actividadLista);
        }
    };

    const estadosNacimientoListar = async (IdPais: number): Promise<void> => {
        const response: Response = await EstadoService.listar(IdPais);
        if (response.error === false) {
            const estadosLista: Estado[] = response.data.value;
            setEstadosNacimientoLista(estadosLista);
        }
    };

    const estadosRecidenciaListar = async (IdEstado: number): Promise<void> => {
        const response: Response = await EstadoService.listar(IdEstado);
        if (response.error === false) {
            const estadosLista: Estado[] = response.data.value;
            setEstadosRecidenciaLista(estadosLista);
        }
    };

    const generosListar = async (): Promise<void> => {
        const response: Response = await GeneroService.listar();
        if (response.error === false) {
            const generosLista: Genero[] = response.data.value;
            setGenerosLista(generosLista);
        }
    };

    const paisListar = async (): Promise<void> => {
        const response: Response = await PaisService.listar();
        if (response.error === false) {
            const paisesLista: Pais[] = response.data.value;
            setPaisesLista(paisesLista);
        }
    };

    const ciudadesRecidenciaListar = async (IdEstado: string | number): Promise<void> => {
        const response: Response = await CiudadService.listar(IdEstado, "");
        if (response.error === false) {
            const ciudadesRecidenciaLista: Ciudad[] = response.data.value;
            setCiudadesRecidenciaLista(ciudadesRecidenciaLista);
        }
    };

    const coloniaListar = async (IdCiudad: string | number): Promise<void> => {
        const response: Response = await ColoniaService.listar(IdCiudad, "");
        if (response.error === false) {
            const coloniaLista: Colonia[] = response.data.value;
            setColoniaLista(coloniaLista);
        }
    }

    const calcularAntiguedad = (): void => {
        const fechaIngreso = new Date(cliente.trabajo.fechaIngreso);
        const fechaSalida = new Date(cliente.trabajo.fechaSalida);

        let años = fechaSalida.getFullYear() - fechaIngreso.getFullYear();
        let meses = fechaSalida.getMonth() - fechaIngreso.getMonth();
        let dias = fechaSalida.getDate() - fechaIngreso.getDate();

        if (dias < 0) {
            meses--;
            const ultimoMes = new Date(fechaSalida.getFullYear(), fechaSalida.getMonth(), 0).getDate();
            dias += ultimoMes;
        }

        if (meses < 0) {
            años--;
            meses += 12;
        }

        const partes: string[] = [];

        if (!isNaN(años) && años > 0) {
            partes.push(`${años} año${años > 1 ? "s" : ""}`);
        }

        if (!isNaN(meses) && meses > 0) {
            partes.push(`${meses} mes${meses > 1 ? "es" : ""}`);
        }

        if (!isNaN(dias) && dias > 0) {
            partes.push(`${dias} día${dias > 1 ? "s" : ""}`);
        }

        let letras = "0 días";

        if (partes.length === 1) {
            letras = partes[0];
        } else if (partes.length > 1) {
            letras = partes.slice(0, -1).join(", ") + " y " + partes.slice(-1);
        }

        setCliente((prev: Cliente) => ({
            ...prev,
            trabajo: {
                ...prev.trabajo,
                antiguedad: letras
            }
        }));
    }

    const calcularHorasTrabajo = (): void => {
        // const horaEntrada: string = cliente.trabajo.horaEntrada;
        // const horaSalida: string = cliente.trabajo.horaSalida;
        const [h1, m1] = cliente.trabajo.horaEntrada.split(":").map(Number);
        const [h2, m2] = cliente.trabajo.horaSalida.split(":").map(Number);
        const minutosEntrada = h1 * 60 + m1;
        const minutosSalida = h2 * 60 + m2;

        const diferencia = minutosSalida - minutosEntrada;

        const horas = Math.floor(diferencia / 60);
        const minutos = diferencia % 60;
        const tiempoTrabajado: string = `${horas} horas, ${minutos} minutos`;

        setCliente((prev: Cliente) => ({ ...prev, trabajo: { ...prev.trabajo, tiempoTrabajado } }));
    }

    const clienteValidarDatos = (): boolean => {
        let value: boolean = true;

        const { nombres, paterno, materno, CURP, lugarEntrevista } = cliente

        if (nombres.length === 0) value = false
        if (paterno.length === 0) value = false
        if (materno.length === 0) value = false
        if (CURP.length === 0) value = false
        if (lugarEntrevista.length === 0) value = false

        return value;
    }

    const clienteNuevo = (): void => {
        setCliente(objectCliente)
        navigate(`/dashboard/?page=${1}&cliente=0`);
        setArraysolicitudCredito([]);
        setValue("1");
    }

    const clienteGuardar = async (cliente: Cliente): Promise<void> => {

        const value: boolean = clienteValidarDatos();

        if (value) {
            const response: Response = await ClienteService.guardar(cliente);
            console.log(cliente)
            const { data } = response;
            if (data.error === false) {
                const IdCliente: number = data.value.IdCliente;
                setCliente((prev: Cliente) => ({ ...prev, IdCliente }));
                navigate(`/dashboard/?page=${1}&cliente=${IdCliente}`);
                toast.success("Datos guardados")
            }
        } else {
            setIsOpenModalError(true);
        }

    }

    const solicitudCreditoValidar = (): boolean => {

        let value: boolean = true;

        const { tipo: { IdTipo }, monto: { IdMonto }, plazo: { IdPlazo }, formaPago: { IdFormaPago }, status: { IdStatus }, } = solicitudCredito
        console.log({ IdTipo, IdMonto, IdPlazo, IdFormaPago, IdStatus })
        if (Number(IdTipo) === 0) { setIndexFaltanteSolicitud(prev => [...prev, { index: "IdTipo", value: true }]); value = false; }
        if (Number(IdMonto) === 0) { setIndexFaltanteSolicitud(prev => [...prev, { index: "IdMonto", value: true }]); value = false; }
        if (Number(IdPlazo) === 0) { setIndexFaltanteSolicitud(prev => [...prev, { index: "IdPlazo", value: true }]); value = false; }
        if (Number(IdFormaPago) === 0) { setIndexFaltanteSolicitud(prev => [...prev, { index: "IdFormaPago", value: true }]); value = false; }
        if (Number(IdStatus) === 0) { setIndexFaltanteSolicitud(prev => [...prev, { index: "IdStatus", value: true }]); value = false; }
        console.log(indexDatoFaltanteSolicitud)
        return value

    }

    const solicitudCreditoGuardar = async (): Promise<void> => {
        setIndexFaltanteSolicitud([]);
        const value: boolean = solicitudCreditoValidar();

        if (value) {
            const response: Response = await SolicitudCreditoService.guardar({ ...solicitudCredito, usuario: { IdUsuario: usuario.IdUsuario, nombre: usuario.nombreCompleto } });
            if (response.error === false) {
                toast.success("Solicitud de credito guardada");
                solicitudCreditoListar(cliente.IdCliente);
                setSolicitudCredito(response.data.value)
                // setIsOpenModalSolicitud(false);
            }
        } else {
            setIsOpenModalSolicitudError(true);
        }

    }

    const colsActividad: TableColumn<Actividad>[] = [
        {
            // name: <Label style={{ fontWeight: "", color: colors.negro, fontSize: 15 }} > Actividad / Trabajo </Label>,
            cell: (actividad: Actividad) =>
                <Label
                    style={{ color: colors.negro, fontSize: 13, whiteSpace: 'normal', cursor: "pointer" }}
                    onClick={() => {
                        setCliente((prev: Cliente) => ({ ...prev, actividadProfecion: { ...prev.actividadProfecion, IdActividad: actividad.IdActividad, value: actividad.value, tipo: { ...prev.actividadProfecion.tipo, IdActividadTipo: actividad.tipo.IdActividadTipo, value: actividad.tipo.value } } }));
                        setIsOpenModalActividad(false);
                    }}
                >
                    {actividad.value} ({actividad.tipo.value})
                </Label>,
            width: data.isDesktop ? "70%" : "100%"
        },
        {
            name: <Label style={{ fontWeight: "", color: colors.negro, fontSize: 15 }} ></Label>,
            cell: (actividad: Actividad) =>
                <Col style={{ textAlign: "center" }} >
                    <IconButton
                        style={{ color: colors.secundario }}
                        onClick={() => {
                            setCliente((prev: Cliente) => ({ ...prev, actividadProfecion: { ...prev.actividadProfecion, IdActividad: actividad.IdActividad, value: actividad.value, tipo: { ...prev.actividadProfecion.tipo, IdActividadTipo: actividad.tipo.IdActividadTipo, value: actividad.tipo.value } } }));
                            setIsOpenModalActividad(false);
                        }}
                    >
                        <Check />
                    </IconButton>
                </Col>,

            width: "30%",
        },
    ]

    const columnaSolicitudCredito: TableColumn<SolicitudCredito>[] = [
        {
            name: <Label style={{ fontWeight: "", fontSize: 14, alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <PersonOutlineOutlined /> Tipo </Label>,
            cell: (solicitudCredito: SolicitudCredito) =>
                <Label
                    style={{ color: colors.negro, fontSize: 12, whiteSpace: 'normal', cursor: "pointer", fontWeight: "bold" }}
                    onDoubleClick={() => {
                        setSolicitudCredito(solicitudCredito);
                        setIsOpenModalSolicitud(true);
                    }}
                >
                    {solicitudCredito.tipo.value}
                </Label>,
            width: "150px"
        },

        {
            name: <Label style={{ fontWeight: "", fontSize: 14, alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <CalendarTodayOutlined /> Fecha </Label>,
            cell: (solicitudCredito: SolicitudCredito) =>
                <Label
                    style={{ color: colors.negro, fontSize: 12, whiteSpace: 'normal', cursor: "pointer" }}
                    onDoubleClick={() => {
                        setSolicitudCredito(solicitudCredito);
                        setIsOpenModalSolicitud(true);
                    }}
                >
                    {FechaTool.formato(solicitudCredito.fechaCreacion)}, {TiempoTool.convertTimeTo12HourFormat(solicitudCredito.horaCreacion)}
                </Label>,
            width: "250px"
        },
        {
            name: <Label style={{ fontWeight: "", fontSize: 14, alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <InfoOutlined /> Estatus </Label>,
            cell: (solicitudCredito: SolicitudCredito) =>
                <Label
                    style={{ color: colors.negro, fontSize: 12, whiteSpace: 'normal', cursor: "pointer", fontWeight: "bold" }}
                    onDoubleClick={() => {
                        setSolicitudCredito(solicitudCredito);
                        setIsOpenModalSolicitud(true);
                    }}
                >
                    {solicitudCredito.status.value}
                </Label>,
        },
        {
            name: <Label style={{ fontWeight: "", fontSize: 14, alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <AttachMoneyOutlined /> Monto </Label>,
            cell: (solicitudCredito: SolicitudCredito) =>
                <Label
                    style={{ color: colors.negro, fontSize: 12, whiteSpace: 'normal', cursor: "pointer" }}
                    onDoubleClick={() => {
                        setSolicitudCredito(solicitudCredito);
                        setIsOpenModalSolicitud(true);
                    }}
                >
                    $ {Numero.formatoComas(solicitudCredito.monto.value)}
                </Label>,
        },
        {
            name: <Label style={{ fontWeight: "", fontSize: 14, alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <PriceCheckOutlined /> Aprobado </Label>,
            cell: (solicitudCredito: SolicitudCredito) =>
                <Label
                    style={{ color: colors.negro, fontSize: 12, whiteSpace: 'normal', cursor: "pointer" }}
                    onDoubleClick={() => {
                        setSolicitudCredito(solicitudCredito);
                        setIsOpenModalSolicitud(true);
                    }}
                >
                    $ {Numero.formatoComas(solicitudCredito.montoAprobado)}
                </Label>,
        },
        {
            name: <Label style={{ fontWeight: "", fontSize: 14, alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <EditCalendarOutlined /> Plazo </Label>,
            cell: (solicitudCredito: SolicitudCredito) =>
                <>
                    <Label
                        style={{ color: colors.negro, fontSize: 12, whiteSpace: 'normal', cursor: "pointer" }}
                        data-tooltip-id={`plazo-${cliente.IdCliente}`}
                        onDoubleClick={() => {
                            setSolicitudCredito(solicitudCredito);
                            setIsOpenModalSolicitud(true);
                        }}
                    >
                        {solicitudCredito.plazo.value.replace(/\s*\(.*?\)/g, "")}
                    </Label>
                    <Tooltip
                        id={`plazo-${cliente.IdCliente}`}
                        place="right-start"
                    >
                        <p style={{ fontSize: 14 }} >
                            {solicitudCredito.plazo.value}
                        </p>
                    </Tooltip>
                </>,
        },
        {
            name: <Label style={{ fontWeight: "", fontSize: 14, alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} > <PaymentOutlined /> Forma de Pago </Label>,
            cell: (solicitudCredito: SolicitudCredito) =>
                <Label
                    style={{ color: colors.negro, fontSize: 12, whiteSpace: 'normal', cursor: "pointer" }}
                    onDoubleClick={() => {
                        setSolicitudCredito(solicitudCredito);
                        setIsOpenModalSolicitud(true);
                    }}
                >
                    {solicitudCredito.formaPago.value}
                </Label>,
        },

        {
            name: <Label style={{ fontWeight: "", fontSize: 14, alignItems: "center", justifyContent: "center", gap: 6, color: colors.secundario }} >  </Label>,
            cell: (solicitudCredito: SolicitudCredito) =>
                <>
                    <IconButton
                        style={{ color: colors.rojo, marginRight: 5 }}
                        onClick={() => {
                            setIsOpenModalEliniarSolicitud(true);
                            setSolicitudCredito(solicitudCredito);
                        }}
                    >
                        <DeleteOutlineOutlined />
                    </IconButton>
                    <IconButton
                        style={{ color: colors.secundario }}
                        onClick={() => {
                            setSolicitudCredito(solicitudCredito);
                            setIsOpenModalPDF(true);
                        }}
                    >
                        {/* < PictureAsPdfOutlined /> */}
                        <img
                            src={icoPDF}
                            alt="No imagen"
                            style={{ height: 20 }}
                        />
                    </IconButton>
                </>,
        },
    ]

    return (
        <>
            <ToastContainer position="bottom-right" autoClose={5000} limit={3} />
            <main style={{ width: "100%", minHeight: "100vh", /*height:/* "100vh", maxHeight: "auto",*/ backgroundColor: colors.blanco }} >
                <section style={{ marginLeft: data.isDesktop ? 80 : 0, position: "relative" }} >
                    <Block height={"3vh"} />
                    <Row style={{ marginRight: 0, marginLeft: 0, }} >
                        <Col>
                            <Label style={{ fontSize: 24, fontWeight: "bold", color: colors.negro }} >
                                Datos del Cliente {cliente.IdCliente !== 0 && `(${cliente.nombres} ${cliente.paterno} ${cliente.materno})`} <br />
                                <span style={{ fontWeight: "normal", fontSize: 14 }} >Agrega o modifica clientes junto a sus solicitudess de credito</span>
                            </Label>
                        </Col>

                    </Row>

                    <Row style={{ marginRight: 0, marginLeft: 0 }} >
                        <Col style={{ minWidth: data.isDesktop ? "70%" : "100%", width: data.isDesktop ? "70%" : "100%", maxWidth: data.isDesktop ? "70%" : "100%" }} >
                            <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                <InputGroup >
                                    <Input
                                        id="cliente.lugarEntrevista"
                                        name="lugarEntrevista"
                                        type="text"
                                        placeholder=" "
                                        value={cliente.lugarEntrevista}
                                        style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent", cursor: cliente.IdCliente === 0 ? "text" : "not-allowed" }}
                                        onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                            if (cliente.lugarEntrevista.length <= 200) cambioCliente(name, value);
                                        }}
                                        disabled={cliente.IdCliente !== 0}
                                    />
                                    <Label style={{ marginLeft: 0 }} >{data.isDesktop ? "Lugar donde se lleva a cabo la entrevista" : "Lugar de la entrevista"}</Label>
                                </InputGroup>
                                <span>{cliente.lugarEntrevista.length}/200</span>
                            </FormGroup>
                        </Col>
                        <Col style={{ minWidth: data.isDesktop ? "30%" : "100%", width: data.isDesktop ? "30%" : "100%", maxWidth: data.isDesktop ? "30%" : "100%" }} >
                            <FormGroup className={`google-input ${cliente.fechaEntrevista ? "has-value" : ""}`}>
                                <InputGroup>
                                    <Input
                                        type="date"
                                        id="cliente.fechaEntrevista"
                                        name="fechaEntrevista"
                                        value={cliente.fechaEntrevista}
                                        style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent", cursor: cliente.IdCliente === 0 ? "pointer" : "not-allowed" }}
                                        onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                            cambioCliente(name, value);
                                            // setFechaLetras(FechaTool.convertirLetras(value));
                                        }}
                                        disabled={cliente.IdCliente !== 0}
                                    />
                                    <Label htmlFor="fechaEntrevista">
                                        Fecha de la entrevista
                                    </Label>
                                </InputGroup>
                                <span>
                                    {FechaTool.convertirLetras(cliente.fechaEntrevista)}
                                </span>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                        <Col style={{ textAlign: "right" }} >
                            {
                                cliente.IdCliente !== 0 &&
                                <IconButton
                                    style={{ marginRight: 10, color: colors.secundario }}
                                    onClick={() => {
                                        cargarURL();
                                    }}
                                >
                                    <Cached />
                                </IconButton>
                            }
                            <IconButton
                                style={{ marginRight: 10, color: colors.secundario }}
                                onClick={() => {
                                    clienteNuevo();
                                }}
                            >
                                <Add />
                            </IconButton>
                            <IconButton
                                style={{ color: colors.secundario }}
                                onClick={() => {
                                    clienteGuardar(cliente);
                                }}
                            >
                                <Save />
                            </IconButton>
                        </Col>
                    </Row>
                    <Box sx={{ typography: 'body1', marginRight: 2, marginLeft: 2, }}>

                        <TabContext value={value}>

                            <Box sx={{ borderBottom: 1, borderColor: 'divider', overflowX: 'auto', whiteSpace: 'nowrap' }}>
                                <MyTabs
                                    value={value}
                                    onChange={handleChange}
                                    aria-label="lab API tabs example"
                                    variant="scrollable" // Permite scroll automático en pantallas pequeñas
                                    scrollButtons="auto" // Muestra botones de desplazamiento cuando es necesario
                                >
                                    <Tab style={{ color: colors.secundario, fontSize: 16 }} label="DATOS DEL CLIENTE" value="1" />
                                    <Tab style={{ color: colors.secundario, fontSize: 16 }} label="DOCUMENTOS DEL CLIENTE" value="2" />
                                    <Tab style={{ color: colors.secundario, fontSize: 16 }} label="TERCEROS RELACIONADOS" value="3" />
                                    <Tab style={{ color: colors.secundario, fontSize: 16 }} label="PERFIL TRANSACCIONAL" value="4" />
                                    <Tab style={{ color: colors.secundario, fontSize: 16 }} label="DATOS DEL TRABAJO" value="5" />
                                    <Tab style={{ color: colors.secundario, fontSize: 16 }} label="UBICACION" value="7" />
                                    {cliente.IdCliente > 0 && <Tab style={{ color: colors.secundario, fontSize: 16 }} label="SOLICITUDES DE CREDITO" value="6" />}
                                    {/* <Tab style={{ color: colors.blue, fontSize: 16 }} label="Imágenes" value="4" /> */}
                                </MyTabs>
                            </Box>

                            <TabPanel value="1" style={{ padding: 0, }} >
                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                                    <Label style={{ fontSize: 16, color: colors.secundario }} >
                                        DATOS GENERALES
                                    </Label>
                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0 }} >
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.nombres"
                                                    name="nombres"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.nombres}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                        cambioCliente(name, value);
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Nombre(s)</Label>
                                            </InputGroup>
                                            <span style={{ fontSize: 14, fontStyle: 'italic' }}>Compelto sin abreviaturas</span>
                                        </FormGroup>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.paterno"
                                                    name="paterno"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.paterno}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                        cambioCliente(name, value);
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Apellido Paterno</Label>
                                            </InputGroup>
                                            <span style={{ fontSize: 14, fontStyle: 'italic' }}>Compelto sin abreviaturas</span>
                                        </FormGroup>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.materno"
                                                    name="materno"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.materno}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                        cambioCliente(name, value);
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Apellido Materno</Label>
                                            </InputGroup>
                                            <span style={{ fontSize: 14, fontStyle: 'italic' }}>Completo sin abreviaturas</span>
                                        </FormGroup>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${cliente.fechaEntrevista ? "has-value" : ""}`}>
                                            <InputGroup>
                                                <Input
                                                    type="date"
                                                    id="cliente.fechaNacimiento"
                                                    name="fechaNacimiento"
                                                    value={cliente.fechaNacimiento}
                                                    style={{
                                                        boxShadow: "none",
                                                        borderColor: colors.secundario,
                                                        borderRadius: 0,
                                                        backgroundColor: "transparent",
                                                    }}
                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                        cambioCliente(name, value);
                                                    }}
                                                />
                                                <Label htmlFor="fechaEntrevista">
                                                    Fecha de Nacimiento
                                                </Label>
                                            </InputGroup>
                                            <span style={{ fontSize: 14, fontStyle: 'italic' }}>
                                                {FechaTool.convertirLetras(cliente.fechaNacimiento)}
                                            </span>
                                        </FormGroup>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 5 }} >
                                            <InputLabel
                                                id="demo-simple-select-label"
                                                sx={{
                                                    color: colors.secundario,
                                                    '&.MuiInputLabel-shrink': {
                                                        fontSize: '1.2rem',
                                                        color: colors.secundario
                                                    },
                                                }}
                                            >
                                                Genero
                                            </InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                name="genero.IdGenero"
                                                style={{ borderRightColor: "transparent" }}
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                }}
                                                value={cliente.genero.IdGenero.toString()}
                                                // label="Genero"
                                                onChange={({ target: { name, value } }: SelectChangeEvent) => {
                                                    setCliente((prev: Cliente) => ({ ...prev, genero: { ...prev.genero, IdGenero: Number(value) } }))
                                                }}
                                            >
                                                {
                                                    generosLista.map((item: Genero) => {
                                                        return <MenuItem value={item.IdGenero}>{item.value}</MenuItem>
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Col>
                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0 }} >
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 5 }} >
                                            <InputLabel
                                                id="demo-simple-select-label"
                                                sx={{
                                                    color: colors.secundario,
                                                    '&.MuiInputLabel-shrink': {
                                                        fontSize: '1.2rem',
                                                        color: colors.secundario
                                                    },
                                                }}
                                            >
                                                Pais de Nacimiento
                                            </InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                name="paisNacimiento.IdPais"
                                                style={{ borderRightColor: "transparent" }}
                                                value={cliente.paisNacimiento.IdPais.toString()}
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                }}
                                                onChange={({ target: { name, value } }: SelectChangeEvent) => {
                                                    setCliente((prev: Cliente) => ({ ...prev, paisNacimiento: { ...prev.paisNacimiento, IdPais: Number(value) } }))
                                                    estadosNacimientoListar(Number(value))
                                                }}
                                            >
                                                {
                                                    paisesLista.map((item: Pais) => {
                                                        return <MenuItem value={item.IdPais}>{item.value}</MenuItem>
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 5 }} >
                                            <InputLabel
                                                id="demo-simple-select-label"
                                                sx={{
                                                    color: colors.secundario,
                                                    '&.MuiInputLabel-shrink': {
                                                        fontSize: '1.2rem',
                                                        color: colors.secundario
                                                    },
                                                }}
                                            >
                                                Nacionalidad {cliente.nacionalidad.IdPais.toString()}
                                            </InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                name="paisNacionalidad.IdPais"
                                                style={{ borderRightColor: "transparent" }}
                                                value={cliente.nacionalidad.IdPais.toString()}
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                }}
                                                onChange={({ target: { name, value } }: SelectChangeEvent) => {
                                                    setCliente((prev: Cliente) => ({ ...prev, nacionalidad: { ...prev.nacionalidad, IdPais: Number(value) } }))
                                                }}
                                            >
                                                {
                                                    paisesLista.map((item: Pais) => {
                                                        return <MenuItem value={item.IdPais}>{item.value}</MenuItem>
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 5 }} >
                                            <InputLabel
                                                id="demo-simple-select-label"
                                                sx={{
                                                    color: colors.secundario,
                                                    '&.MuiInputLabel-shrink': {
                                                        fontSize: '1.2rem',
                                                        color: colors.secundario
                                                    },
                                                }}
                                            >
                                                Estado de Nacimiento
                                            </InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                name="estadoNacimiento.IdEstado"
                                                style={{ borderRightColor: "transparent" }}
                                                value={cliente.estadoNacimiento.IdEstado.toString()}
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                }}
                                                // value={cliente.estadoNacimiento.IdEstado.toString()}
                                                // label="Genero"
                                                onChange={({ target: { name, value } }: SelectChangeEvent) => {
                                                    setCliente((prev: Cliente) => ({ ...prev, estadoNacimiento: { ...prev.estadoNacimiento, IdEstado: Number(value) } }))
                                                }}
                                            >
                                                {
                                                    estadosNacimientoLista.map((item: Estado) => {
                                                        return <MenuItem value={item.IdEstado}>{item.clave} {item.value}</MenuItem>
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Col>

                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0 }} >
                                    <Col style={{ minWidth: data.isDesktop ? "50%" : "100%", width: data.isDesktop ? "50%" : "100%", maxWidth: data.isDesktop ? "50%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.cliente.actividadProfecion"
                                                    name="cliente.actividadProfecion"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.actividadProfecion.IdActividad === 0 ? "" : `${cliente.actividadProfecion.value + " (" + cliente.actividadProfecion.tipo.value})`}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    // onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                    //     cambioCliente(name, value);
                                                    // }}
                                                    onClick={() => {
                                                        setIsOpenModalActividad(true);
                                                        actividadesListar("");
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >
                                                    {
                                                        data.isDesktop ?
                                                            "Actividad, Ocupación, Profesión, Actividad o Giro a que se dedique el cliente"
                                                            :
                                                            "Actividad, Ocupación, Profesión, Actividad"
                                                    }
                                                </Label>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "50%" : "100%", width: data.isDesktop ? "50%" : "100%", maxWidth: data.isDesktop ? "50%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.relacionDeNegocios"
                                                    name="relacionDeNegocios"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.relacionDeNegocios}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                        cambioCliente(name, value);
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Motivo de la relación de negocios</Label>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row style={{ width: "100%", marginTop: 0 }} >
                                    <Block height={"1px"} backgroundColor={colors.secundario} />
                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                                    <Label style={{ fontSize: 16, color: colors.secundario }} >
                                        DOMICILIO PARTICULAR EN EL REGULAR DE RESIDENCIA
                                    </Label>
                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0 }} >
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 5 }} >
                                            <InputLabel
                                                id="demo-simple-select-label"
                                                sx={{
                                                    color: colors.secundario,
                                                    '&.MuiInputLabel-shrink': {
                                                        fontSize: '1.2rem',
                                                        color: colors.secundario
                                                    },
                                                }}
                                            >
                                                Pais
                                            </InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                name="paisRecidencia.IdPais"
                                                style={{ borderRightColor: "transparent" }}
                                                value={cliente.paisRecidencia.IdPais.toString()}
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                }}
                                                // value={cliente.estadoNacimiento.IdEstado.toString()}
                                                // label="Genero"
                                                onChange={({ target: { name, value } }: SelectChangeEvent) => {
                                                    setCliente((prev: Cliente) => ({ ...prev, paisNacimiento: { ...prev.paisNacimiento, IdPais: Number(value) } }))
                                                    estadosRecidenciaListar(Number(value))
                                                }}
                                            >
                                                {
                                                    paisesLista.map((item: Pais) => {
                                                        return <MenuItem value={item.IdPais}>{item.value}</MenuItem>
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 5 }} >
                                            <InputLabel
                                                id="demo-simple-select-label"
                                                sx={{
                                                    color: colors.secundario,
                                                    '&.MuiInputLabel-shrink': {
                                                        fontSize: '1.2rem',
                                                        color: colors.secundario
                                                    },
                                                }}
                                            >
                                                Estado
                                            </InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                name="estadoRecidencia.IdEstado"
                                                style={{ borderRightColor: "transparent" }}
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                }}
                                                value={cliente.estadoRecidencia.IdEstado.toString()}
                                                // label="Genero"
                                                onChange={({ target: { name, value } }: SelectChangeEvent) => {
                                                    setCliente((prev: Cliente) => ({ ...prev, estadoRecidencia: { ...prev.estadoRecidencia, IdEstado: Number(value) } }))
                                                    ciudadesRecidenciaListar(Number(value))
                                                }}
                                            >
                                                {
                                                    estadosRecidenciaLista.map((item: Estado) => {
                                                        return <MenuItem value={item.IdEstado}>{item.clave} {item.value}</MenuItem>
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 5 }} >
                                            <InputLabel
                                                id="demo-simple-select-label"
                                                sx={{
                                                    color: colors.secundario,
                                                    '&.MuiInputLabel-shrink': {
                                                        fontSize: '1.2rem',
                                                        color: colors.secundario
                                                    },
                                                }}
                                            >
                                                Ciudad
                                            </InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                name="ciudadRecidencia.IdCiudad"
                                                style={{ borderRightColor: "transparent" }}
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                }}
                                                value={cliente.ciudadRecidencia.IdCiudad.toString()}
                                                // label="Genero"
                                                onChange={({ target: { name, value } }: SelectChangeEvent) => {
                                                    setCliente((prev: Cliente) => ({ ...prev, ciudadRecidencia: { ...prev.ciudadRecidencia, IdCiudad: Number(value) } }))
                                                    coloniaListar(Number(value))

                                                }}
                                            >
                                                {
                                                    ciudadesRecidenciaLista.map((item: Ciudad) => {
                                                        return <MenuItem value={item.IdCiudad}>{item.value}</MenuItem>
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 5 }} >
                                            <InputLabel
                                                id="demo-simple-select-label"
                                                sx={{
                                                    color: colors.secundario,
                                                    '&.MuiInputLabel-shrink': {
                                                        fontSize: '1.2rem',
                                                        color: colors.secundario
                                                    },
                                                }}
                                            >
                                                Municipio
                                            </InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                name="municipioRecidencia.IdCiudad"
                                                style={{ borderRightColor: "transparent" }}
                                                value={cliente.municipioRecidencia.IdCiudad.toString()}
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                }}
                                                onChange={({ target: { name, value } }: SelectChangeEvent) => {
                                                    setCliente((prev: Cliente) => ({ ...prev, municipioRecidencia: { ...prev.municipioRecidencia, IdCiudad: Number(value) } }))
                                                }}
                                            >
                                                {
                                                    ciudadesRecidenciaLista.map((item: Ciudad) => {
                                                        return <MenuItem value={item.IdCiudad}>{item.value}</MenuItem>
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 5 }} >
                                            <InputLabel
                                                id="demo-simple-select-label"
                                                sx={{
                                                    color: colors.secundario,
                                                    '&.MuiInputLabel-shrink': {
                                                        fontSize: '1.2rem',
                                                        color: colors.secundario
                                                    },
                                                }}
                                            >
                                                Colonia
                                            </InputLabel>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                name="colonia.IdColonia"
                                                style={{ borderRightColor: "transparent" }}
                                                sx={{
                                                    '& .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                        borderTop: 'none',
                                                        borderLeft: 'none',
                                                        borderRight: 'none',
                                                        borderRadius: 0,
                                                        borderBottom: `1px solid ${colors.secundario}`
                                                    },
                                                }}
                                                // value={cliente.estadoNacimiento.IdEstado.toString()}
                                                value={cliente.colonia.IdColonia.toString()}
                                                onChange={({ target: { name, value } }: SelectChangeEvent) => {
                                                    setCliente((prev: Cliente) => ({ ...prev, colonia: { ...prev.colonia, IdColonia: Number(value) } }))
                                                    const data: Colonia | undefined = coloniaLista.find((item: Colonia) => item.IdColonia = Number(value))
                                                    if (data !== undefined) {
                                                        setCliente((prev: Cliente) => ({ ...prev, CP: data.CP }))
                                                    }
                                                }}
                                            >
                                                {
                                                    coloniaLista.map((item: Colonia) => {
                                                        return (<MenuItem value={item.IdColonia}>{item.value}</MenuItem>)
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Col>
                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0 }} >
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.CP"
                                                    name="CP"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.CP}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                        cambioCliente(name, value);
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Codigo Postal</Label>
                                            </InputGroup>

                                            <span style={{ fontSize: 14, fontStyle: 'italic' }} data-tooltip-id="my-tooltip" >
                                                Este dato puede autocompletarse <Help style={{ height: 18, width: 18 }} />
                                            </span>
                                            <Tooltip
                                                id="my-tooltip"
                                                place="right-start"
                                            >
                                                <p>
                                                    Al seleccionar la colonia, el sistema asignará automáticamente el código postal correspondiente. <br />
                                                    Este valor puede ser editado por el usuario si así lo requiere.
                                                </p>
                                            </Tooltip>
                                        </FormGroup>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "40%" : "100%", width: data.isDesktop ? "40%" : "100%", maxWidth: data.isDesktop ? "40%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.calleAvenida"
                                                    name="calleAvenida"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.calleAvenida}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                        cambioCliente(name, value);
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Nombre de la calle o avenida</Label>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.numeroInterioir"
                                                    name="numeroInterioir"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.numeroInterioir}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                        cambioCliente(name, value);
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >No Interior</Label>
                                            </InputGroup>
                                            {/* <span>Compelto sin abreviaturas</span> */}
                                        </FormGroup>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.numeroExterioir"
                                                    name="numeroExterioir"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.numeroExterioir}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                        cambioCliente(name, value);
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >No Exterior</Label>
                                            </InputGroup>
                                            {/* <span>Compelto sin abreviaturas</span> */}
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row style={{ width: "100%", marginTop: 0 }} > <Block height={"1px"} backgroundColor={colors.secundario} /> </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                                    <Label style={{ fontSize: 16, color: colors.secundario }} >
                                        DATOS DE CONTACTO
                                    </Label>
                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0 }} >
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.numeroTelefono"
                                                    name="numeroTelefono"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.numeroTelefono}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                        value = Numero.soloNumeros(value)
                                                        value = Numero.formatPhoneNumber(value);
                                                        cambioCliente(name, value);
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Numero de Telefono</Label>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.numeroTelefonoExtencion"
                                                    name="numeroTelefonoExtencion"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.numeroTelefonoExtencion}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                        cambioCliente(name, value);
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Extencion</Label>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.correo"
                                                    name="correo"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.correo}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                        cambioCliente(name, value);
                                                        setCorreoValido(Correo.validar(value))
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Correo electronico</Label>
                                            </InputGroup>
                                            {
                                                cliente.correo.length > 0 &&
                                                <span style={{ fontSize: 14, color: correoValida ? colors.secundario : colors.naranja }} >
                                                    {correoValida ? "Correo valido" : <i>Esto no parece ser un correo</i>}
                                                </span>
                                            }
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row style={{ width: "100%", marginTop: 0 }} > <Block height={"1px"} backgroundColor={colors.secundario} /> </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                                    <Label style={{ fontSize: 16, color: colors.secundario }} >
                                        C.U.R.P. y R.F.C.
                                    </Label>
                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0 }} >
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.CURP"
                                                    name="CURP"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.CURP}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                        cambioCliente(name, value.toUpperCase());
                                                        setCorreoValido(Correo.validar(value))
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >C.U.R.P.</Label>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.RFC"
                                                    name="RFC"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.RFC}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                        cambioCliente(name, value.toUpperCase());
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >R.F.C.</Label>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>

                                </Row>
                                <Row style={{ width: "100%", marginTop: 0 }} > <Block height={"1px"} backgroundColor={colors.secundario} /> </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                                    <Label style={{ fontSize: 16, color: colors.secundario }} >
                                        DATOS DE LA INDENTIFICACION DEL CLIENTE
                                    </Label>
                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0 }} >
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.identificacionNombre"
                                                    name="identificacionNombre"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.identificacionNombre}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                        cambioCliente(name, value);
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Nombre de la identificacion *</Label>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.identificacionAutoridadEmite"
                                                    name="identificacionAutoridadEmite"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.identificacionAutoridadEmite}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                        cambioCliente(name, value);
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Autoridad que la emite</Label>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.identificacionNumero"
                                                    name="identificacionNumero"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.identificacionNumero}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                        cambioCliente(name, value);
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Numero de la documentacion</Label>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row style={{ width: "100%", marginTop: 0 }} > <Block height={"1px"} backgroundColor={colors.secundario} /> </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                                    <Label style={{ fontSize: 16, color: colors.secundario }} >
                                        DOMICILIO EN EL EXTRANGERO DONDE PUEDAN RECIBIR CORRESPONDENCIA
                                    </Label>
                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0 }} >
                                    <Col style={{ minWidth: "100%", width: "100%", maxWidth: "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.RFC"
                                                    name="direccionExtranjero"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.direccionExtranjero}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                        cambioCliente(name, value.toUpperCase());
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Domicilio en el extrangero</Label>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>

                                </Row>

                            </TabPanel>

                            <TabPanel value="2" style={{ padding: 0, }} >

                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                                    <Label style={{ fontSize: 16, color: colors.secundario }} >
                                        DOCUMENTACION ORIGINAL OFICIAL
                                    </Label>
                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0 }} >
                                    <Col style={{ minWidth: data.isDesktop ? "25%" : "100%", width: data.isDesktop ? "25%" : "100%", maxWidth: data.isDesktop ? "25%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                Credencial para votar
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let tieneCredencialParaVotar: number = cliente.tieneCredencialParaVotar
                                                    tieneCredencialParaVotar === 1 ? tieneCredencialParaVotar = 0 : tieneCredencialParaVotar = 1

                                                    setCliente((prev: Cliente) => ({ ...prev, tieneCredencialParaVotar }))
                                                }}
                                            >
                                                {cliente.tieneCredencialParaVotar === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                        <span style={{ fontSize: 14, fontStyle: 'italic' }}>
                                            Con fotografia y firma
                                        </span>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "25%" : "100%", width: data.isDesktop ? "25%" : "100%", maxWidth: data.isDesktop ? "25%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                Extrangeros - Pasaporte
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let tieneExtrangeroPasaporte: number = cliente.tieneExtrangeroPasaporte
                                                    tieneExtrangeroPasaporte === 1 ? tieneExtrangeroPasaporte = 0 : tieneExtrangeroPasaporte = 1

                                                    setCliente((prev: Cliente) => ({ ...prev, tieneExtrangeroPasaporte }))
                                                }}
                                            >
                                                {cliente.tieneExtrangeroPasaporte === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                        <span data-tooltip-id="INM" style={{ fontSize: 14, fontStyle: 'italic' }} >
                                            Doc. Expedido por INM. <Help style={{ height: 18, width: 18 }} />
                                        </span>
                                        <Tooltip
                                            id="INM"
                                            place="right-start"
                                        >
                                            <p>
                                                Instituto Nacional de Migración (INM)
                                            </p>
                                        </Tooltip>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "25%" : "100%", width: data.isDesktop ? "25%" : "100%", maxWidth: data.isDesktop ? "25%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                Otra Identificacion
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let tieneOtraIdentificacion: number = cliente.tieneOtraIdentificacion
                                                    tieneOtraIdentificacion === 1 ? tieneOtraIdentificacion = 0 : tieneOtraIdentificacion = 1
                                                    if (tieneOtraIdentificacion === 0) setCliente((prev: Cliente) => ({ ...prev, tieneOtraIdentificacionDescripcion: "" }))
                                                    setCliente((prev: Cliente) => ({ ...prev, tieneOtraIdentificacion }))
                                                }}
                                            >
                                                {cliente.tieneOtraIdentificacion === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                        <span style={{ fontSize: 14, fontStyle: 'italic' }}>
                                            Vigente emitida por una autoridad mexicana
                                        </span>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "25%" : "100%", width: data.isDesktop ? "25%" : "100%", maxWidth: data.isDesktop ? "25%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`} style={{ marginTop: 0 }} >
                                            <InputGroup >
                                                <Input
                                                    id="cliente.tieneOtraIdentificacionDescripcion"
                                                    name="tieneOtraIdentificacionDescripcion"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.tieneOtraIdentificacionDescripcion}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                        cambioCliente(name, value);
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Identificacion</Label>
                                            </InputGroup>
                                            {/* <span style={{ fontSize: 14, fontStyle: 'italic' }}>Vigente emitida por una autoridad mexicana</span> */}
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <Row style={{ width: "100%", marginTop: 0 }} > <Block height={"1px"} backgroundColor={colors.secundario} /> </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                                    <Label style={{ fontSize: 16, color: colors.secundario }} >
                                        CONSTANCIA DE CURP Y CEDULA DE IDENTIFICACION FISCAL
                                    </Label>
                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0 }} >
                                    <Col style={{ minWidth: data.isDesktop ? "25%" : "100%", width: data.isDesktop ? "25%" : "100%", maxWidth: data.isDesktop ? "25%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                CURP expedida por la secretaria de gobernacion
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let tieneCRUP: number = cliente.tieneCRUP
                                                    tieneCRUP === 1 ? tieneCRUP = 0 : tieneCRUP = 1

                                                    setCliente((prev: Cliente) => ({ ...prev, tieneCRUP }))
                                                }}
                                            >
                                                {cliente.tieneCRUP === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "25%" : "100%", width: data.isDesktop ? "25%" : "100%", maxWidth: data.isDesktop ? "25%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                Cedula de identificacion fiscal SAT
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let tieneCedulaSAT: number = cliente.tieneCedulaSAT
                                                    tieneCedulaSAT === 1 ? tieneCedulaSAT = 0 : tieneCedulaSAT = 1

                                                    setCliente((prev: Cliente) => ({ ...prev, tieneCedulaSAT }))
                                                }}
                                            >
                                                {cliente.tieneCedulaSAT === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>

                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "25%" : "100%", width: data.isDesktop ? "25%" : "100%", maxWidth: data.isDesktop ? "25%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                Constancia de FIEL actualizada
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let tieneFIEL: number = cliente.tieneFIEL
                                                    tieneFIEL === 1 ? tieneFIEL = 0 : tieneFIEL = 1
                                                    setCliente((prev: Cliente) => ({ ...prev, tieneFIEL }))
                                                }}
                                            >
                                                {cliente.tieneFIEL === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                    </Col>
                                </Row>

                                <Row style={{ width: "100%", marginTop: 0 }} >
                                    <Block height={"1px"} backgroundColor={colors.secundario} />
                                </Row>

                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                                    <Label style={{ fontSize: 16, color: colors.secundario }} >
                                        COMPROBANTE QUE ACREDITA EL DOMICILIO DEL CLIENTE
                                    </Label>
                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0 }} >
                                    <Col style={{ minWidth: data.isDesktop ? "25%" : "100%", width: data.isDesktop ? "25%" : "100%", maxWidth: data.isDesktop ? "25%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                Recibo de pagop de servicio
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let tieneReciboPagoServicio: number = cliente.tieneReciboPagoServicio
                                                    tieneReciboPagoServicio === 1 ? tieneReciboPagoServicio = 0 : tieneReciboPagoServicio = 1
                                                    if (tieneReciboPagoServicio === 0) setCliente((prev: Cliente) => ({ ...prev, tieneReciboPagoServicioDescripcion: "" }))

                                                    setCliente((prev: Cliente) => ({ ...prev, tieneReciboPagoServicio }))
                                                }}
                                            >
                                                {cliente.tieneReciboPagoServicio === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                        <span style={{ fontSize: 14, fontStyle: 'italic' }}>
                                            No mayor a 3 meses de su emision.
                                        </span>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "25%" : "100%", width: data.isDesktop ? "25%" : "100%", maxWidth: data.isDesktop ? "25%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`} style={{ marginTop: 0 }} >
                                            <InputGroup >
                                                <Input
                                                    id="cliente.tieneReciboPagoServicioDescripcion"
                                                    name="tieneReciboPagoServicioDescripcion"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.tieneReciboPagoServicioDescripcion}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                        cambioCliente(name, value);
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Servicio</Label>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "25%" : "100%", width: data.isDesktop ? "25%" : "100%", maxWidth: data.isDesktop ? "25%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                Contrato de arrendamiento vigente
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let tieneContratoArrendamientoVigente: number = cliente.tieneContratoArrendamientoVigente
                                                    tieneContratoArrendamientoVigente === 1 ? tieneContratoArrendamientoVigente = 0 : tieneContratoArrendamientoVigente = 1

                                                    setCliente((prev: Cliente) => ({ ...prev, tieneContratoArrendamientoVigente }))
                                                }}
                                            >
                                                {cliente.tieneContratoArrendamientoVigente === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>

                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "25%" : "100%", width: data.isDesktop ? "25%" : "100%", maxWidth: data.isDesktop ? "25%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                Estado de cuenta bancarios
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let tieneEstadoCuentaBancario: number = cliente.tieneEstadoCuentaBancario
                                                    tieneEstadoCuentaBancario === 1 ? tieneEstadoCuentaBancario = 0 : tieneEstadoCuentaBancario = 1
                                                    setCliente((prev: Cliente) => ({ ...prev, tieneEstadoCuentaBancario }))
                                                }}
                                            >
                                                {cliente.tieneEstadoCuentaBancario === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                        <span style={{ fontSize: 14, fontStyle: 'italic' }}>
                                            No mayor a 3 meses de su emision.
                                        </span>
                                    </Col>
                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                                    <Col style={{ minWidth: data.isDesktop ? "25%" : "100%", width: data.isDesktop ? "25%" : "100%", maxWidth: data.isDesktop ? "25%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                Constancia de inscripcion al RFC
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let tieneConstanciaInscripcionRFC: number = cliente.tieneConstanciaInscripcionRFC
                                                    tieneConstanciaInscripcionRFC === 1 ? tieneConstanciaInscripcionRFC = 0 : tieneConstanciaInscripcionRFC = 1

                                                    setCliente((prev: Cliente) => ({ ...prev, tieneConstanciaInscripcionRFC }))
                                                }}
                                            >
                                                {cliente.tieneConstanciaInscripcionRFC === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                    </Col>
                                </Row>

                            </TabPanel>

                            <TabPanel value="3" style={{ padding: 0, }} >
                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                                    <Label style={{ fontSize: 16, color: colors.secundario }} >
                                        IDENTIFICACION DEL BENEFICIARIO CONTROLADOR, PROVEEDOR DE RECURSOS Y PPE <Help data-tooltip-id="PPE" style={{ height: 18, width: 18 }} />
                                    </Label>
                                    <Tooltip
                                        id="PPE"
                                        place="right-end"
                                    > Persona Políticamente Expuesta (PPE) </Tooltip>
                                </Row>

                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 5 }} >

                                    <Col style={{ minWidth: data.isDesktop ? "40%" : "100%", width: data.isDesktop ? "40%" : "100%", maxWidth: data.isDesktop ? "40%" : "100%" }} >
                                        <Block height={14} ></Block>
                                        <Label>
                                            ¿Actua ested a nombre propio o por cuenta de un tercero?
                                        </Label> <br />

                                    </Col>

                                    <Col style={{ minWidth: data.isDesktop ? "10%" : "100%", width: data.isDesktop ? "10%" : "100%", maxWidth: data.isDesktop ? "10%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                Propio
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let actuaNombrePropio: number = cliente.actuaNombrePropio
                                                    actuaNombrePropio = actuaNombrePropio === 1 ? 0 : 1
                                                    if (actuaNombrePropio === 0) ComponentsTool.focus("cliente.actuaNombrePropio.descripcion");
                                                    setCliente((prev: Cliente) => ({ ...prev, actuaNombrePropio }))
                                                }}
                                            >
                                                {cliente.actuaNombrePropio === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                    </Col>

                                    <Col style={{ minWidth: data.isDesktop ? "10%" : "100%", width: data.isDesktop ? "10%" : "100%", maxWidth: data.isDesktop ? "10%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                Terceros
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let actuaNombrePropio: number = cliente.actuaNombrePropio
                                                    actuaNombrePropio === 1 ? actuaNombrePropio = 0 : actuaNombrePropio = 1
                                                    if (actuaNombrePropio === 0) ComponentsTool.focus("cliente.actuaNombrePropio.descripcion");

                                                    setCliente((prev: Cliente) => ({ ...prev, actuaNombrePropio }))
                                                }}
                                            >
                                                {cliente.actuaNombrePropio === 0 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                    </Col>

                                    <Col style={{ minWidth: data.isDesktop ? "40%" : "100%", width: data.isDesktop ? "40%" : "100%", maxWidth: data.isDesktop ? "40%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`} style={{ marginTop: 0 }}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.actuaNombrePropioDescripcion.descripcion"
                                                    name="actuaNombrePropioDescripcion"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.actuaNombrePropioDescripcion}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                        cambioCliente(name, value);
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} ></Label>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>


                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0 }} >
                                    <span data-tooltip-id="INM" style={{ fontSize: 14, fontStyle: 'italic' }} >
                                        Cuando declare que actua por cuenta de un tercero, recabara los mismos datos y documentos del cliente.
                                    </span>
                                </Row>
                                <Row style={{ width: "100%", marginTop: 0 }} > <Block height={"1px"} backgroundColor={colors.secundario} /> </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 20 }} >

                                    <Col style={{ minWidth: data.isDesktop ? "40%" : "100%", width: data.isDesktop ? "40%" : "100%", maxWidth: data.isDesktop ? "40%" : "100%" }} >
                                        <Block height={14} ></Block>
                                        <Label>
                                            ¿Alguien distinto a usted aporta recursos para realizar pagos?
                                        </Label> <br />
                                    </Col>

                                    <Col style={{ minWidth: data.isDesktop ? "10%" : "100%", width: data.isDesktop ? "10%" : "100%", maxWidth: data.isDesktop ? "10%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                No
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let alguienAporteRecursos: number = cliente.alguienAporteRecursos
                                                    alguienAporteRecursos === 1 ? alguienAporteRecursos = 0 : alguienAporteRecursos = 1


                                                    setCliente((prev: Cliente) => ({ ...prev, alguienAporteRecursos }))
                                                }}
                                            >
                                                {cliente.alguienAporteRecursos === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                    </Col>

                                    <Col style={{ minWidth: data.isDesktop ? "10%" : "100%", width: data.isDesktop ? "10%" : "100%", maxWidth: data.isDesktop ? "10%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                Si
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let alguienAporteRecursos: number = cliente.alguienAporteRecursos
                                                    alguienAporteRecursos === 1 ? alguienAporteRecursos = 0 : alguienAporteRecursos = 1

                                                    setCliente((prev: Cliente) => ({ ...prev, alguienAporteRecursos }))
                                                }}
                                            >
                                                {cliente.alguienAporteRecursos === 0 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                    </Col>

                                    <Col style={{ minWidth: data.isDesktop ? "40%" : "100%", width: data.isDesktop ? "40%" : "100%", maxWidth: data.isDesktop ? "40%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`} style={{ marginTop: 0 }}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.alguienAporteRecursos.descripcion"
                                                    name="alguienAporteRecursosDescripcion"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.alguienAporteRecursosDescripcion}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                        cambioCliente(name, value);
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} ></Label>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>


                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0 }} >
                                    <span data-tooltip-id="INM" style={{ fontSize: 14, fontStyle: 'italic' }} >
                                        Cuando declare que alguien mas aportara recursos para realizar los pagos, recabara los mismos datos y documentos del cliente.
                                    </span>
                                </Row>
                                <Row style={{ width: "100%", marginTop: 0 }} > <Block height={"1px"} backgroundColor={colors.secundario} /> </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 20 }} >

                                    <Col style={{ minWidth: data.isDesktop ? "100%" : "100%", width: data.isDesktop ? "100" : "100%", maxWidth: data.isDesktop ? "100" : "100%" }} >
                                        <Block height={14} ></Block>
                                        <Label style={{ textAlign: "justify" }} >
                                            ¿Usted, su cónyuge o pariente hasta el segundo grado por consanguinidad o afinidad desempeña o ha desempeñado funciones públicas destacadas en un país extranjero o en territorio nacional, considerando entre otros, a los jefes de estado o de gobierno, líderes políticos, funcionarios gubernamentales, judiciales o militares de lata jerarquía, altos ejecutivos de empresas estatales o funcionaros o miembros de partidos políticos y organizaciones internacionales?
                                        </Label> <br />
                                    </Col>
                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                                    <Col style={{ minWidth: data.isDesktop ? "10%" : "100%", width: data.isDesktop ? "10%" : "100%", maxWidth: data.isDesktop ? "10%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                No
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let tieneFamiliaPolitica: number = cliente.tieneFamiliaPolitica
                                                    tieneFamiliaPolitica === 1 ? tieneFamiliaPolitica = 0 : tieneFamiliaPolitica = 1
                                                    if (tieneFamiliaPolitica === 1) ComponentsTool.focus("cliente.familiaPoliticaNombreCompleto");
                                                    setCliente((prev: Cliente) => ({ ...prev, tieneFamiliaPolitica }))
                                                }}
                                            >
                                                {cliente.tieneFamiliaPolitica === 0 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                    </Col>

                                    <Col style={{ minWidth: data.isDesktop ? "10%" : "100%", width: data.isDesktop ? "10%" : "100%", maxWidth: data.isDesktop ? "10%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                Si
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let tieneFamiliaPolitica: number = cliente.tieneFamiliaPolitica
                                                    tieneFamiliaPolitica === 1 ? tieneFamiliaPolitica = 0 : tieneFamiliaPolitica = 1
                                                    if (tieneFamiliaPolitica === 1) ComponentsTool.focus("cliente.familiaPoliticaNombreCompleto");

                                                    setCliente((prev: Cliente) => ({ ...prev, tieneFamiliaPolitica }))
                                                }}
                                            >
                                                {cliente.tieneFamiliaPolitica === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                    </Col>
                                    {
                                        cliente.tieneFamiliaPolitica === 1 &&
                                        <>
                                            <Col style={{ minWidth: data.isDesktop ? "26%" : "100%", width: data.isDesktop ? "26" : "100%", maxWidth: data.isDesktop ? "26%" : "100%" }} >
                                                <FormGroup className={`google-input ${false ? "move-left" : ""}`} style={{ marginTop: 0 }}>
                                                    <InputGroup >
                                                        <Input
                                                            id="cliente.familiaPoliticaNombreCompleto"
                                                            name="familiaPoliticaNombreCompleto"
                                                            type="text"
                                                            placeholder=" "
                                                            value={cliente.familiaPoliticaNombreCompleto}
                                                            style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                            onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                                cambioCliente(name, value);
                                                            }}
                                                        />
                                                        <Label style={{ marginLeft: 0 }} >Nombre completo sin abreviaturas</Label>
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                            <Col style={{ minWidth: data.isDesktop ? "26%" : "100%", width: data.isDesktop ? "26%" : "100%", maxWidth: data.isDesktop ? "26%" : "100%" }} >
                                                <FormGroup className={`google-input ${false ? "move-left" : ""}`} style={{ marginTop: 0 }}>
                                                    <InputGroup >
                                                        <Input
                                                            id="cliente.familiaPoliticaParentesto"
                                                            name="familiaPoliticaParentesto"
                                                            type="text"
                                                            placeholder=" "
                                                            value={cliente.familiaPoliticaParentesto}
                                                            style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                            onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                                cambioCliente(name, value);
                                                            }}
                                                        />
                                                        <Label style={{ marginLeft: 0 }} >Parentesto</Label>
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                            <Col style={{ minWidth: data.isDesktop ? "28%" : "100%", width: data.isDesktop ? "28%" : "100%", maxWidth: data.isDesktop ? "28%" : "100%" }} >
                                                <FormGroup className={`google-input ${false ? "move-left" : ""}`} style={{ marginTop: 0 }}>
                                                    <InputGroup >
                                                        <Input
                                                            id="cliente.familiaPoliticaPuesto"
                                                            name="familiaPoliticaPuesto"
                                                            type="text"
                                                            placeholder=" "
                                                            value={cliente.familiaPoliticaPuesto}
                                                            style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                            onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                                cambioCliente(name, value);
                                                            }}
                                                        />
                                                        <Label style={{ marginLeft: 0 }} >Puesto</Label>
                                                    </InputGroup>
                                                </FormGroup>
                                            </Col>
                                        </>
                                    }
                                </Row>
                                {
                                    cliente.tieneFamiliaPolitica === 1 &&
                                    <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                                        <Col style={{ minWidth: data.isDesktop ? "10%" : "100%", width: data.isDesktop ? "10%" : "100%", maxWidth: data.isDesktop ? "10%" : "100%" }} >
                                            <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                                <Label>
                                                    Nacional
                                                </Label>
                                                <IconButton
                                                    disableRipple
                                                    style={{
                                                        marginRight: 10,
                                                        color: colors.secundario,
                                                    }}
                                                    onClick={() => {

                                                        let familiaPoliticaNacionalExtranjero: number = cliente.familiaPoliticaNacionalExtranjero
                                                        familiaPoliticaNacionalExtranjero === 1 ? familiaPoliticaNacionalExtranjero = 0 : familiaPoliticaNacionalExtranjero = 1


                                                        setCliente((prev: Cliente) => ({ ...prev, familiaPoliticaNacionalExtranjero }))
                                                    }}
                                                >
                                                    {cliente.familiaPoliticaNacionalExtranjero === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                                </IconButton>
                                            </FormControl>
                                        </Col>

                                        <Col style={{ minWidth: data.isDesktop ? "10%" : "100%", width: data.isDesktop ? "10%" : "100%", maxWidth: data.isDesktop ? "10%" : "100%" }} >
                                            <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                                <Label>
                                                    Extranjero
                                                </Label>
                                                <IconButton
                                                    disableRipple
                                                    style={{
                                                        marginRight: 10,
                                                        color: colors.secundario,
                                                    }}
                                                    onClick={() => {

                                                        let familiaPoliticaNacionalExtranjero: number = cliente.familiaPoliticaNacionalExtranjero
                                                        familiaPoliticaNacionalExtranjero === 1 ? familiaPoliticaNacionalExtranjero = 0 : familiaPoliticaNacionalExtranjero = 1

                                                        setCliente((prev: Cliente) => ({ ...prev, familiaPoliticaNacionalExtranjero }))
                                                    }}
                                                >
                                                    {cliente.familiaPoliticaNacionalExtranjero === 0 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                                </IconButton>
                                            </FormControl>
                                        </Col>
                                        <Col style={{ minWidth: data.isDesktop ? "26%" : "100%", width: data.isDesktop ? "26%" : "100%", maxWidth: data.isDesktop ? "26%" : "100%" }} >
                                            <FormGroup className={`google-input ${cliente.fechaEntrevista ? "has-value" : ""}`}>
                                                <InputGroup>
                                                    <Input
                                                        type="date"
                                                        id="cliente.familiaPoliticaFechaInicioPeriodo"
                                                        name="familiaPoliticaFechaInicioPeriodo"
                                                        value={cliente.familiaPoliticaFechaInicioPeriodo}
                                                        style={{
                                                            boxShadow: "none",
                                                            borderColor: colors.secundario,
                                                            borderRadius: 0,
                                                            backgroundColor: "transparent",
                                                        }}
                                                        onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                            cambioCliente(name, value);
                                                        }}
                                                    />
                                                    <Label htmlFor="fechaEntrevista">
                                                        Dia, Mes, año de inicio del periodo
                                                    </Label>
                                                </InputGroup>
                                                <span style={{ fontSize: 14, fontStyle: 'italic' }}>
                                                    {FechaTool.convertirLetras(cliente.familiaPoliticaFechaInicioPeriodo)}
                                                </span>
                                            </FormGroup>
                                        </Col>
                                        <Col style={{ minWidth: data.isDesktop ? "26%" : "100%", width: data.isDesktop ? "26%" : "100%", maxWidth: data.isDesktop ? "26%" : "100%" }} >
                                            <FormGroup className={`google-input ${cliente.fechaEntrevista ? "has-value" : ""}`}>
                                                <InputGroup>
                                                    <Input
                                                        type="date"
                                                        id="cliente.familiaPoliticaFechaFinalPeriodo"
                                                        name="familiaPoliticaFechaFinalPeriodo"
                                                        value={cliente.familiaPoliticaFechaFinalPeriodo}
                                                        style={{
                                                            boxShadow: "none",
                                                            borderColor: colors.secundario,
                                                            borderRadius: 0,
                                                            backgroundColor: "transparent",
                                                        }}
                                                        onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
                                                            cambioCliente(name, value);
                                                        }}
                                                    />
                                                    <Label htmlFor="fechaEntrevista">
                                                        Dia, Mes, año de fin del periodo
                                                    </Label>
                                                </InputGroup>
                                                <span style={{ fontSize: 14, fontStyle: 'italic' }}>
                                                    {FechaTool.convertirLetras(cliente.familiaPoliticaFechaFinalPeriodo)}
                                                </span>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                }
                            </TabPanel>

                            <TabPanel value="4" style={{ padding: 0, }} >
                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                                    <Label style={{ fontSize: 16, color: colors.secundario }} >
                                        ORIGEN PRINCIPAL DE SUS INGRESOS
                                    </Label>
                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                Sueldo
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let tieneSueldo: number = cliente.tieneSueldo
                                                    tieneSueldo === 1 ? tieneSueldo = 0 : tieneSueldo = 1


                                                    setCliente((prev: Cliente) => ({ ...prev, tieneSueldo }))
                                                }}
                                            >
                                                {cliente.tieneSueldo === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                    </Col>

                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                Honorarios
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let tieneHonorarios: number = cliente.tieneHonorarios
                                                    tieneHonorarios === 1 ? tieneHonorarios = 0 : tieneHonorarios = 1

                                                    setCliente((prev: Cliente) => ({ ...prev, tieneHonorarios }))
                                                }}
                                            >
                                                {cliente.tieneHonorarios === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                Venta de Negocios
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let tieneVentaNegocio: number = cliente.tieneVentaNegocio
                                                    tieneVentaNegocio === 1 ? tieneVentaNegocio = 0 : tieneVentaNegocio = 1

                                                    setCliente((prev: Cliente) => ({ ...prev, tieneVentaNegocio }))
                                                }}
                                            >
                                                {cliente.tieneVentaNegocio === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                Ventas de su Inmueble
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let tieneVentaInmueble: number = cliente.tieneVentaInmueble
                                                    tieneVentaInmueble === 1 ? tieneVentaInmueble = 0 : tieneVentaInmueble = 1

                                                    setCliente((prev: Cliente) => ({ ...prev, tieneVentaInmueble }))
                                                }}
                                            >
                                                {cliente.tieneVentaInmueble === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                Herencia
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let tieneHerencia: number = cliente.tieneHerencia
                                                    tieneHerencia === 1 ? tieneHerencia = 0 : tieneHerencia = 1

                                                    setCliente((prev: Cliente) => ({ ...prev, tieneHerencia }))
                                                }}
                                            >
                                                {cliente.tieneHerencia === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                    </Col>
                                </Row>
                                <Row style={{ width: "100%", marginTop: 0 }} > <Block height={"1px"} backgroundColor={colors.secundario} /> </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                                    <Label style={{ fontSize: 16, color: colors.secundario }} >
                                        ESTIMACION DE OPERACIONES QUE REALIZA
                                    </Label>
                                </Row>
                                <div style={{ width: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch', }}                                >
                                    <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: 0, borderRadius: '12px', overflow: 'hidden', }}>
                                        <thead>
                                            <tr>
                                                <th style={{ border: '1px solid #ccc', padding: 8, backgroundColor: colors.secundario, color: colors.blanco, width: "25%" }}>Tipo de Operaciones</th>
                                                <th style={{ border: '1px solid #ccc', padding: 8, backgroundColor: colors.secundario, color: colors.blanco, width: "25%" }}>Monto de Operaciones</th>
                                                <th style={{ border: '1px solid #ccc', padding: 8, backgroundColor: colors.secundario, color: colors.blanco, width: "25%" }}>Numero de operaciones</th>
                                                <th style={{ border: '1px solid #ccc', padding: 8, backgroundColor: colors.secundario, color: colors.blanco, width: "25%" }}>Frecuencia de Operaciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={{ border: '1px solid #ccc', padding: 8, fontWeight: "bold", width: "25%" }}>Efectivo</td>
                                                <td style={{ border: '1px solid #ccc', padding: 8, width: "25%" }}>
                                                    {cliente.operaciones.efectivo.IdMonto.toString()}
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        style={{ borderRightColor: "transparent" }}
                                                        sx={SelectStyle.sx}
                                                        value={cliente.operaciones.efectivo.IdMonto.toString()}
                                                        onChange={({ target: { value } }: SelectChangeEvent) => {
                                                            setCliente((prev: Cliente) => ({ ...prev, operaciones: { ...prev.operaciones, efectivo: { ...prev.operaciones.efectivo, IdMonto: Number(value) } } }))
                                                        }}
                                                    >
                                                        {
                                                            operacionesMontos.map((item: Valor) => {
                                                                return <MenuItem value={item.Id}>{item.valor}</MenuItem>
                                                            })
                                                        }
                                                    </Select>
                                                </td>
                                                <td style={{ border: '1px solid #ccc', padding: 8, width: "25%" }}>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        style={{ borderRightColor: "transparent" }}
                                                        sx={SelectStyle.sx}
                                                        value={cliente.operaciones.efectivo.IdNumero.toString()}
                                                        onChange={({ target: { value } }: SelectChangeEvent) => {
                                                            setCliente((prev: Cliente) => ({ ...prev, operaciones: { ...prev.operaciones, efectivo: { ...prev.operaciones.efectivo, IdNumero: Number(value) } } }))
                                                        }}
                                                    >
                                                        {
                                                            operacionesNumeros.map((item: Valor) => {
                                                                return <MenuItem value={item.Id}>{item.valor}</MenuItem>
                                                            })
                                                        }
                                                    </Select>
                                                </td>
                                                <td style={{ border: '1px solid #ccc', padding: 8, width: "25%" }}>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        style={{ borderRightColor: "transparent" }}
                                                        sx={SelectStyle.sx}
                                                        value={cliente.operaciones.efectivo.IdFrecuencia.toString()}
                                                        onChange={({ target: { value } }: SelectChangeEvent) => {
                                                            setCliente((prev: Cliente) => ({ ...prev, operaciones: { ...prev.operaciones, efectivo: { ...prev.operaciones.efectivo, IdFrecuencia: Number(value) } } }))
                                                        }}
                                                    >
                                                        {
                                                            operacionesFrecuencias.map((item: Valor) => {
                                                                return <MenuItem value={item.Id}>{item.valor}</MenuItem>
                                                            })
                                                        }
                                                    </Select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ border: '1px solid #ccc', padding: 8, fontWeight: "bold" }}>Tranferencia</td>
                                                <td style={{ border: '1px solid #ccc', padding: 8, width: "25%" }}>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        style={{ borderRightColor: "transparent" }}
                                                        sx={SelectStyle.sx}
                                                        value={cliente.operaciones.transferencia.IdMonto.toString()}
                                                        onChange={({ target: { value } }: SelectChangeEvent) => {
                                                            setCliente((prev: Cliente) => ({ ...prev, operaciones: { ...prev.operaciones, transferencia: { ...prev.operaciones.transferencia, IdMonto: Number(value) } } }))
                                                        }}
                                                    >
                                                        {
                                                            operacionesMontos.map((item: Valor) => {
                                                                return <MenuItem value={item.Id}>{item.valor}</MenuItem>
                                                            })
                                                        }
                                                    </Select>
                                                </td>
                                                <td style={{ border: '1px solid #ccc', padding: 8, width: "25%" }}>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        style={{ borderRightColor: "transparent" }}
                                                        sx={SelectStyle.sx}
                                                        value={cliente.operaciones.transferencia.IdNumero.toString()}
                                                        onChange={({ target: { value } }: SelectChangeEvent) => {
                                                            setCliente((prev: Cliente) => ({ ...prev, operaciones: { ...prev.operaciones, transferencia: { ...prev.operaciones.transferencia, IdNumero: Number(value) } } }))
                                                        }}
                                                    >
                                                        {
                                                            operacionesNumeros.map((item: Valor) => {
                                                                return <MenuItem value={item.Id}>{item.valor}</MenuItem>
                                                            })
                                                        }
                                                    </Select>
                                                </td>
                                                <td style={{ border: '1px solid #ccc', padding: 8, width: "25%" }}>
                                                    <Select
                                                        labelId="demo-simple-select-label"
                                                        id="demo-simple-select"
                                                        style={{ borderRightColor: "transparent" }}
                                                        sx={SelectStyle.sx}
                                                        value={cliente.operaciones.transferencia.IdFrecuencia.toString()}
                                                        onChange={({ target: { value } }: SelectChangeEvent) => {
                                                            setCliente((prev: Cliente) => ({ ...prev, operaciones: { ...prev.operaciones, transferencia: { ...prev.operaciones.transferencia, IdFrecuencia: Number(value) } } }))
                                                        }}
                                                    >
                                                        {
                                                            operacionesFrecuencias.map((item: Valor) => {
                                                                return <MenuItem value={item.Id}>{item.valor}</MenuItem>
                                                            })
                                                        }
                                                    </Select>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                </div>

                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                                    <Col style={{ minWidth: data.isDesktop ? "25%" : "100%", width: data.isDesktop ? "25" : "100%", maxWidth: data.isDesktop ? "25%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                Moneda Nacional
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let esMonedaNacional: number = cliente.esMonedaNacional
                                                    esMonedaNacional === 1 ? esMonedaNacional = 0 : esMonedaNacional = 1


                                                    setCliente((prev: Cliente) => ({ ...prev, esMonedaNacional }))
                                                }}
                                            >
                                                {cliente.esMonedaNacional === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                    </Col>

                                    <Col style={{ minWidth: data.isDesktop ? "25%" : "100%", width: data.isDesktop ? "25" : "100%", maxWidth: data.isDesktop ? "25%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                Moneda Extranjera
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let esMonedaExtranjera: number = cliente.esMonedaExtranjera
                                                    esMonedaExtranjera === 1 ? esMonedaExtranjera = 0 : esMonedaExtranjera = 1

                                                    setCliente((prev: Cliente) => ({ ...prev, esMonedaExtranjera }))
                                                }}
                                            >
                                                {cliente.esMonedaExtranjera === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                    </Col>

                                    <Col style={{ minWidth: data.isDesktop ? "25%" : "100%", width: data.isDesktop ? "25" : "100%", maxWidth: data.isDesktop ? "25%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label>
                                                Activos Virtuales
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    marginRight: 10,
                                                    color: colors.secundario,
                                                }}
                                                onClick={() => {

                                                    let esActivosVirtuales: number = cliente.esActivosVirtuales
                                                    esActivosVirtuales === 1 ? esActivosVirtuales = 0 : esActivosVirtuales = 1

                                                    setCliente((prev: Cliente) => ({ ...prev, esActivosVirtuales }))
                                                }}
                                            >
                                                {cliente.esActivosVirtuales === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                    </Col>


                                </Row>

                            </TabPanel>

                            <TabPanel value="5" style={{ padding: 0 }} >
                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                                    <Label style={{ fontSize: 16, color: colors.secundario }} >
                                        INFORMACION DE LA EMRPRESA
                                    </Label>
                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0 }} >
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.trabajo.nombreEmpresa"
                                                    name="trabajo.nombreEmpresa"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.trabajo.nombreEmpresa}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                                        setCliente((prev: Cliente) => ({ ...prev, trabajo: { ...prev.trabajo, nombreEmpresa: value } }));
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Nombre de la empresa</Label>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.trabajo.giroActividadEmpresa"
                                                    name="trabajo.giroActividadEmpresa"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.trabajo.giroActividadEmpresa}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                                        setCliente((prev: Cliente) => ({ ...prev, trabajo: { ...prev.trabajo, giroActividadEmpresa: value } }));
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Giro o actividad de la empresa</Label>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "40%" : "100%", width: data.isDesktop ? "40%" : "100%", maxWidth: data.isDesktop ? "40%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.trabajo.direccionEmpresa"
                                                    name="trabajo.direccionEmpresa"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.trabajo.direccionEmpresa}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                                        setCliente((prev: Cliente) => ({ ...prev, trabajo: { ...prev.trabajo, direccionEmpresa: value } }));
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Dirección de la empresa</Label>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.trabajo.telefonoEmpresa"
                                                    name="trabajo.telefonoEmpresa"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.trabajo.telefonoEmpresa}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                                        value = Numero.soloNumeros(value)
                                                        setCliente((prev: Cliente) => ({ ...prev, trabajo: { ...prev.trabajo, telefonoEmpresa: value } }));
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Telefono de la empresa</Label>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row style={{ width: "100%", marginTop: 0 }} > <Block height={"1px"} backgroundColor={colors.secundario} /> </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                                    <Label style={{ fontSize: 16, color: colors.secundario }} >
                                        INFORMACION DEL EMPLEO
                                    </Label>
                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0 }} >
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.trabajo.puestoCargo"
                                                    name="trabajo.puestoCargo"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.trabajo.puestoCargo}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                                        setCliente((prev: Cliente) => ({ ...prev, trabajo: { ...prev.trabajo, puestoCargo: value } }));
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Puesto o cargo</Label>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.trabajo.areaDepartamento"
                                                    name="areaDepartamento"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.trabajo.areaDepartamento}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                                        setCliente((prev: Cliente) => ({ ...prev, trabajo: { ...prev.trabajo, areaDepartamento: value } }));
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Área o departamento</Label>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.trabajo.fechaIngreso"
                                                    name="trabajo.fechaIngreso"
                                                    type="date"
                                                    placeholder=" "
                                                    value={cliente.trabajo.fechaIngreso}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                                        setCliente((prev: Cliente) => ({ ...prev, trabajo: { ...prev.trabajo, fechaIngreso: value } }));
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Fecha de ingreso</Label>
                                            </InputGroup>
                                            <span style={{ fontSize: 14, fontStyle: 'italic' }}>
                                                {FechaTool.convertirLetras(cliente.trabajo.fechaIngreso)}
                                            </span>
                                        </FormGroup>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.trabajo.fechaSalida"
                                                    name="trabajo.fechaSalida"
                                                    type="date"
                                                    placeholder=" "
                                                    value={cliente.trabajo.fechaSalida}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                                        setCliente((prev: Cliente) => ({ ...prev, trabajo: { ...prev.trabajo, fechaSalida: value } }));
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Fecha de salida</Label>
                                            </InputGroup>
                                            <span style={{ fontSize: 14, fontStyle: 'italic' }}>
                                                {FechaTool.convertirLetras(cliente.trabajo.fechaSalida)}
                                            </span>
                                        </FormGroup>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.trabajo.antiguedad"
                                                    name="trabajo.antiguedad"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.trabajo.antiguedad}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                                        setCliente((prev: Cliente) => ({ ...prev, trabajo: { ...prev.trabajo, antiguedad: value } }));
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Antiguedad</Label>
                                            </InputGroup>
                                            <span
                                                style={{ fontSize: 14, cursor: "pointer" }}
                                                onClick={() => calcularAntiguedad()}
                                            >
                                                Calcular antigüedad
                                            </span>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0 }} >
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormControl fullWidth style={{ marginTop: 0, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label style={{ marginTop: 5 }} >
                                                Trabaja en Lunes
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    color: colors.secundario,

                                                }}
                                                onClick={() => {
                                                    let trabajaLunes: number = cliente.trabajo.trabajaLunes
                                                    trabajaLunes === 1 ? trabajaLunes = 0 : trabajaLunes = 1
                                                    setCliente((prev: Cliente) => ({ ...prev, trabajo: { ...prev.trabajo, trabajaLunes } }))
                                                }}
                                            >
                                                {cliente.trabajo.trabajaLunes === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                        <FormControl fullWidth style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label style={{ marginTop: 5 }} >
                                                Trabaja en Martes
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    color: colors.secundario,

                                                }}
                                                onClick={() => {
                                                    let trabajaMartes: number = cliente.trabajo.trabajaMartes
                                                    trabajaMartes === 1 ? trabajaMartes = 0 : trabajaMartes = 1
                                                    setCliente((prev: Cliente) => ({ ...prev, trabajo: { ...prev.trabajo, trabajaMartes } }))
                                                }}
                                            >
                                                {cliente.trabajo.trabajaMartes === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                        <FormControl fullWidth style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label style={{ marginTop: 5 }} >
                                                Trabaja en Miercoles
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    color: colors.secundario,

                                                }}
                                                onClick={() => {
                                                    let trabajaMiercoles: number = cliente.trabajo.trabajaMiercoles
                                                    trabajaMiercoles === 1 ? trabajaMiercoles = 0 : trabajaMiercoles = 1
                                                    setCliente((prev: Cliente) => ({ ...prev, trabajo: { ...prev.trabajo, trabajaMiercoles } }))
                                                }}
                                            >
                                                {cliente.trabajo.trabajaMiercoles === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                        <FormControl fullWidth style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label style={{ marginTop: 5 }} >
                                                Trabaja en Jueves
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    color: colors.secundario,

                                                }}
                                                onClick={() => {
                                                    let trabajaJueves: number = cliente.trabajo.trabajaJueves
                                                    trabajaJueves === 1 ? trabajaJueves = 0 : trabajaJueves = 1
                                                    setCliente((prev: Cliente) => ({ ...prev, trabajo: { ...prev.trabajo, trabajaJueves } }))
                                                }}
                                            >
                                                {cliente.trabajo.trabajaJueves === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormControl fullWidth style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label style={{ marginTop: 5 }} >
                                                Trabaja en Viernes
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    color: colors.secundario,

                                                }}
                                                onClick={() => {
                                                    let trabajaViernes: number = cliente.trabajo.trabajaViernes
                                                    trabajaViernes === 1 ? trabajaViernes = 0 : trabajaViernes = 1
                                                    setCliente((prev: Cliente) => ({ ...prev, trabajo: { ...prev.trabajo, trabajaViernes } }))
                                                }}
                                            >
                                                {cliente.trabajo.trabajaViernes === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                        <FormControl fullWidth style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label style={{ marginTop: 5 }} >
                                                Trabaja en Sabado
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    color: colors.secundario,

                                                }}
                                                onClick={() => {
                                                    let trabajaSabado: number = cliente.trabajo.trabajaSabado
                                                    trabajaSabado === 1 ? trabajaSabado = 0 : trabajaSabado = 1
                                                    setCliente((prev: Cliente) => ({ ...prev, trabajo: { ...prev.trabajo, trabajaSabado } }))
                                                }}
                                            >
                                                {cliente.trabajo.trabajaSabado === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                        <FormControl fullWidth style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} >
                                            <Label style={{ marginTop: 5 }} >
                                                Trabaja en Domingo
                                            </Label>
                                            <IconButton
                                                disableRipple
                                                style={{
                                                    color: colors.secundario,

                                                }}
                                                onClick={() => {
                                                    let trabajaDomingo: number = cliente.trabajo.trabajaDomingo
                                                    trabajaDomingo === 1 ? trabajaDomingo = 0 : trabajaDomingo = 1
                                                    setCliente((prev: Cliente) => ({ ...prev, trabajo: { ...prev.trabajo, trabajaDomingo } }))
                                                }}
                                            >
                                                {cliente.trabajo.trabajaDomingo === 1 ? <CheckBox /> : <CheckBoxOutlineBlank />}

                                            </IconButton>
                                        </FormControl>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.trabajo.horaEntrada"
                                                    name="trabajo.horaEntrada"
                                                    type="time"
                                                    placeholder=" "
                                                    value={cliente.trabajo.horaEntrada}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                                        setCliente((prev: Cliente) => ({ ...prev, trabajo: { ...prev.trabajo, horaEntrada: value } }));
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Hora de entrada</Label>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.trabajo.horaSalida"
                                                    name="horaSalida"
                                                    type="time"
                                                    placeholder=" "
                                                    value={cliente.trabajo.horaSalida}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                                        setCliente((prev: Cliente) => ({ ...prev, trabajo: { ...prev.trabajo, horaSalida: value } }));
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Hora de salida</Label>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                    <Col style={{ minWidth: data.isDesktop ? "20%" : "100%", width: data.isDesktop ? "20%" : "100%", maxWidth: data.isDesktop ? "20%" : "100%" }} >
                                        <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                            <InputGroup >
                                                <Input
                                                    id="cliente.trabajo.tiempoTrabajado"
                                                    name="trabajo.tiempoTrabajado"
                                                    type="text"
                                                    placeholder=" "
                                                    value={cliente.trabajo.tiempoTrabajado}
                                                    style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                    onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                                        setCliente((prev: Cliente) => ({ ...prev, trabajo: { ...prev.trabajo, tiempoTrabajado: value } }));
                                                    }}
                                                />
                                                <Label style={{ marginLeft: 0 }} >Horas Trabajadas</Label>
                                            </InputGroup>
                                            <span
                                                style={{ fontSize: 14, cursor: "pointer" }}
                                                onClick={() => calcularHorasTrabajo()}
                                            >
                                                Calcular horas trabajadas
                                            </span>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </TabPanel>

                            <TabPanel value="6" style={{ padding: 0 }} >
                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                                    <Col style={{ textAlign: "right" }} >
                                        <IconButton
                                            style={{ marginRight: 10, color: colors.secundario }}
                                            onClick={() => {
                                                solicitudCreditoListar(cliente.IdCliente);
                                                toast.info("Tabla de solicitudes actualizada");
                                            }}
                                        >
                                            <Cached />
                                        </IconButton>
                                        <IconButton
                                            style={{ color: colors.secundario, marginRight: 30 }}
                                            onClick={() => {
                                                setIsOpenModalSolicitud(true);
                                                const IdSolicitudCredito: number = 0;
                                                const IdCliente: number = cliente.IdCliente;
                                                setSolicitudCredito({ ...objectSolicitud, IdSolicitudCredito, IdCliente });
                                            }}
                                        >
                                            <Add />
                                        </IconButton>
                                    </Col>
                                </Row>
                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 0 }} >
                                    <Col style={{ textAlign: "center" }} >
                                        {
                                            arraySolicitudCredito.length === 0 ?
                                                <>
                                                    <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 0 }} >
                                                        <Col>
                                                            <img
                                                                src={iconSearch}
                                                                alt="no imagen"
                                                                style={{ height: 200 }}
                                                            />
                                                        </Col>
                                                    </Row>
                                                    <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                                                        <Col  >
                                                            <Label style={{ fontSize: 18, fontWeight: "bold" }} >
                                                                No se encontraron solicitud de credito
                                                            </Label>
                                                        </Col>
                                                    </Row>
                                                    <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 0 }} >
                                                        <Col>
                                                            <Label style={{ fontSize: 16 }} >
                                                                No hay registros para ete cliente en este momento
                                                            </Label>
                                                        </Col>
                                                    </Row>
                                                    <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 15 }} >
                                                        <Col style={{ display: "flex", justifyContent: "center" }}>
                                                            <Button
                                                                onClick={() => {
                                                                    setIsOpenModalSolicitud(true);
                                                                    const IdSolicitudCredito: number = 0;
                                                                    const IdCliente: number = cliente.IdCliente;
                                                                    setSolicitudCredito({ ...objectSolicitud, IdSolicitudCredito, IdCliente });
                                                                }}
                                                                style={{ boxShadow: "none", width: "auto", display: "flex", alignItems: "center", backgroundColor: colors.secundario }}                                                            >
                                                                <Add style={{ marginRight: 6 }} />
                                                                Nueva Solicitud
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </>
                                                :
                                                <DataTable
                                                    columns={columnaSolicitudCredito}
                                                    data={arraySolicitudCredito}
                                                    highlightOnHover
                                                    customStyles={{
                                                        rows: {
                                                            highlightOnHoverStyle: {
                                                                backgroundColor: "#eeeeee",
                                                                transition: "0.3s",
                                                                cursor: "pointer"
                                                            },
                                                        },
                                                    }}
                                                    onRowClicked={(row) => {
                                                        const now = new Date().getTime();
                                                        if (now - lastClickTime < 300) {
                                                            setSolicitudCredito(row);
                                                            setIsOpenModalSolicitud(true);
                                                        };
                                                        lastClickTime = now;
                                                    }}
                                                />
                                        }
                                    </Col>
                                </Row>

                            </TabPanel>

                            <TabPanel value="7" style={{ padding: 0 }} >

                                <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 30 }} >
                                    <Col className="d-flex justify-content-center" >
                                        {
                                            (Number(cliente.latitud) === 0 || Number(cliente.longitud) === 0) ?
                                                <img
                                                    src={imgMapa}
                                                    alt="No imagen"
                                                    style={{ width: "25%", height: 350 }}
                                                />
                                                :
                                                <iframe
                                                    width="80%"
                                                    height="500"
                                                    style={{ border: 0 }}
                                                    loading="lazy"
                                                    allowFullScreen
                                                    title="Ubicación del cliente en Google Maps"
                                                    src={`https://www.google.com/maps?q=${cliente.latitud},${cliente.longitud}&z=15&output=embed`}

                                                />
                                        }
                                    </Col>
                                </Row>

                                {
                                    (Number(cliente.latitud) === 0 || Number(cliente.longitud) === 0) &&
                                    <>
                                        <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                                            <Col style={{ textAlign: "center" }} >
                                                <Label style={{ fontSize: 16, fontWeight: "bold" }} >
                                                    No se ha registrar la ubicación actual. Para completar este proceso, asegúrese de que el navegador {obtenerNombreNavegador()} tenga habilitados los permisos para acceder a la ubicación (GPS) del dispositivo.
                                                </Label>
                                            </Col>
                                        </Row>


                                    </>
                                }
                                <Row style={{ marginRight: "10%", marginLeft: "10%", marginTop: 10, maxWidth: "80%", width: "80%", minWidth: "80%" }} >
                                    {
                                        (cliente.longitud !== "0" && cliente.latitud !== "0") &&
                                        <Col style={{ textAlign: "left" }} >
                                            <Label
                                                style={{ fontSize: 16, textDecorationLine: "underline", cursor: "pointer", color: colors.rojo, fontWeight: "bold" }}
                                                onClick={() => {
                                                    setCliente((prev: Cliente) => ({ ...prev, latitud: "0", longitud: "0" }));
                                                }}
                                            >
                                                Eliminar ubicacion
                                            </Label>
                                        </Col>
                                    }

                                    <Col style={{ textAlign: !(cliente.longitud !== "0" && cliente.latitud !== "0") ? "center" : "right" }} >
                                        <Label
                                            style={{ fontSize: 16, textDecorationLine: "underline", cursor: "pointer", fontWeight: "bold" }}
                                            onClick={() => obtenerUbicacion()}
                                        >
                                            Haz clik aqui para obtener Ubicacion Actual <MyLocation />
                                        </Label>
                                    </Col>
                                </Row>

                            </TabPanel>

                        </TabContext>

                    </Box>

                    <Block height={"10vh"} />



                </section>

            </main >

            <Modal
                isOpen={isOpenModalActividad}
                fullscreen={data.isMovil}
                style={{ fontFamily: '"Fira Code", monospace', minWidth: "50%" }}
                onOpened={() => {
                    ComponentsTool.focus("actividad.texto");
                }}
            >
                <ModalHeader
                    style={{ backgroundColor: colors.secundario }}
                    close={
                        <Col style={{ textAlign: "right" }} >
                            <IconButton
                                style={{ backgroundColor: colors.secundario, color: colors.blanco }}
                                onClick={() => setIsOpenModalActividad(false)}
                            >
                                <Close />
                            </IconButton>
                        </Col>
                    }
                >
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} >
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            <div style={{ backgroundColor: "#2e5fa3", borderRadius: 10, padding: 10, display: "flex", alignItems: "center", justifyContent: "center" }} >
                                <Work style={{ color: "white", fontSize: 22 }} />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ color: "white", fontSize: 18, fontWeight: 600 }} >
                                    Catalogo de Actividades
                                </span>
                            </div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody style={{ minHeight: data.isDesktop ? "70vh" : "", height: data.isDesktop ? "70vh" : "", maxHeight: data.isDesktop ? "70vh" : "", overflowY: "hidden" }} >
                    <Row style={{ position: "sticky", }} >
                        <Col style={{ minWidth: "100%", width: "100%", maxWidth: "100%", }} >
                            <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                <InputGroup >
                                    <Input
                                        id="actividad.texto"
                                        type="text"
                                        placeholder=" "
                                        value={actividadTexto}
                                        style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                            setActividadTexto(value);
                                        }}
                                        onKeyDown={({ key }: KeyboardEvent<HTMLInputElement>) => {
                                            if (key === "Enter") actividadesListar(actividadTexto);
                                        }}
                                    />
                                    <Label style={{ marginLeft: 0 }} >Buscar actividad por nombre</Label>
                                    <InputGroupText
                                        style={{ cursor: "pointer", color: colors.secundario, backgroundColor: "transparent", borderTopColor: "transparent", borderRightColor: "transparent", borderLeftColor: "transparent", borderBottomColor: colors.secundario, borderRadius: 0 }}
                                    >
                                        <Search />
                                    </InputGroupText>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                    </Row>
                    <div style={{ height: "65vh", overflowY: "auto", marginTop: "-15px" }}>
                        <Row  >
                            <Table
                                columns={colsActividad}
                                data={actividadLista}
                            />
                        </Row>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button
                        style={{ width: 150, backgroundColor: colors.secundario, borderColor: colors.secundario, fontWeight: "bold", boxShadow: "none", marginRight: 10, color: colors.blanco }}
                        onClick={() => setIsOpenModalSolicitud(false)}
                    >
                        <CloseFullscreen />  Cerrar
                    </Button>
                </ModalFooter>
            </Modal >

            <Modal
                isOpen={isOpenModalError}
                centered
                fullscreen={data.isMovil}
                style={{ fontFamily: '"Fira Code", monospace', minWidth: "60%" }}
                onOpened={() => { }}
            >
                <ModalHeader
                    style={{ backgroundColor: colors.secundario }}
                    close={
                        <Col style={{ textAlign: "right" }} >
                            <IconButton
                                style={{ backgroundColor: colors.secundario, color: colors.blanco }}
                                onClick={() => setIsOpenModalError(false)}
                            >
                                <Close />
                            </IconButton>
                        </Col>
                    }
                >
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} >
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            <div style={{ backgroundColor: "#2e5fa3", borderRadius: 10, padding: 10, display: "flex", alignItems: "center", justifyContent: "center" }} >
                                <WarningAmberOutlined style={{ color: "white", fontSize: 22 }} />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ color: "white", fontSize: 18, fontWeight: 600 }} >
                                    Atencion
                                </span>
                            </div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col style={{ minWidth: "70%", width: "70%", maxWidth: "70%", backgroundColor: "transparent" }} >
                            <Row style={{ width: "100%", marginRight: 0, marginLeft: 0 }} >
                                <Label style={{ color: colors.rojo, fontWeight: "bold", fontSize: 18 }} >
                                    <ErrorOutlined style={{ marginRight: 10 }} />
                                    No se guardaron los datos del cliente
                                    <br />
                                    <span style={{ fontSize: 16, fontWeight: "normal", marginLeft: 30 }} >Verifica la siguiente informacion antes de continuar</span>
                                </Label>
                            </Row>
                            <Row style={{ width: "100%", marginRight: 0, marginLeft: 0 }} >
                                <Block height={"1px"} backgroundColor={colors.secundario} />
                            </Row>
                            <Row style={{ width: "100%", marginRight: 0, marginLeft: 0, marginTop: 20 }} >
                                <Col style={{ maxWidth: "10%" }} >
                                    <div style={{ height: 50, width: 50, borderRadius: "50%", backgroundColor: "#E6F0FB", display: "flex", alignItems: "center", justifyContent: "center" }} >
                                        <PersonOutlineOutlined style={{ height: 40, width: 40, color: colors.secundario }} />
                                    </div>
                                </Col>
                                <Col style={{ maxWidth: "90%" }} >
                                    <Label style={{ color: colors.negro, fontWeight: "bold", fontSize: 16 }} >
                                        Nombre, apellido paterno y materno
                                        <br />
                                        <span style={{ fontSize: 14, fontWeight: "normal" }} > Verifique que capturo el nombre, apellido paterno y el apellido materno. </span>
                                    </Label>
                                </Col>
                            </Row>
                            <DropdownItem divider />
                            <Row style={{ width: "100%", marginRight: 0, marginLeft: 0, marginTop: 20 }} >
                                <Col style={{ maxWidth: "10%" }} >
                                    <div style={{ height: 50, width: 50, borderRadius: "50%", backgroundColor: "#E6F0FB", display: "flex", alignItems: "center", justifyContent: "center" }} >
                                        <BadgeOutlined style={{ height: 40, width: 40, color: colors.secundario }} />
                                    </div>
                                </Col>
                                <Col style={{ maxWidth: "90%" }} >
                                    <Label style={{ color: colors.negro, fontWeight: "bold", fontSize: 16 }} >
                                        CURP del cliente
                                        <br />
                                        <span style={{ fontSize: 14, fontWeight: "normal" }} > Verifique que capturo el CURP del cliente </span>
                                    </Label>
                                </Col>
                            </Row>
                            <DropdownItem divider />
                            <Row style={{ width: "100%", marginRight: 0, marginLeft: 0, marginTop: 20 }} >
                                <Col style={{ maxWidth: "10%" }} >
                                    <div style={{ height: 50, width: 50, borderRadius: "50%", backgroundColor: "#E6F0FB", display: "flex", alignItems: "center", justifyContent: "center" }} >
                                        <LocationOnOutlined style={{ height: 40, width: 40, color: colors.secundario }} />
                                    </div>
                                </Col>
                                <Col style={{ maxWidth: "90%" }} >
                                    <Label style={{ color: colors.negro, fontWeight: "bold", fontSize: 16 }} >
                                        Lugar donde se  realiza la entrevista
                                        <br />
                                        <span style={{ fontSize: 14, fontWeight: "normal" }} > Verifique que capturo el lugar donde se esta llevando a cabo la entrevista </span>
                                    </Label>
                                </Col>
                            </Row>


                        </Col>
                        <Col style={{ minWidth: "30%", width: "30%", maxWidth: "30", backgroundColor: "transparent" }} >
                            <center>
                                <img
                                    src={icoNoDato}
                                    alt="No data"
                                    style={{ width: "100%" }}
                                />
                            </center>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button
                        style={{ width: 150, backgroundColor: colors.secundario, fontWeight: "bold", boxShadow: "none" }}
                        onClick={() => setIsOpenModalError(false)}
                    >
                        <CloseFullscreen /> Entendido
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal
                isOpen={isOpenModalSolicitud}
                centered
                fullscreen={data.isMovil}
                style={{ fontFamily: '"Fira Code", monospace', minWidth: "70%" }}
                onOpened={() => {
                    cargarCatalogoSolicitudCredito();
                    setSolicitudCredito({ ...solicitudCredito, montoAprobado: Numero.formatoComas(solicitudCredito.montoAprobado) })
                }}
            >
                <ModalHeader
                    style={{
                        backgroundColor: "#1f4b82",
                        padding: "12px 20px",
                        borderBottom: "none"
                    }}
                    close={
                        <Col style={{ textAlign: "right" }} >
                            <IconButton
                                style={{ color: colors.blanco }}
                                onClick={() => {
                                    cargarCatalogoSolicitudCredito();
                                }}
                            >
                                <Cached />
                            </IconButton>
                            <IconButton
                                style={{ color: colors.blanco }}
                                onClick={() => {
                                    setIsOpenModalSolicitud(false);
                                    setSolicitudCredito(objectSolicitud);
                                }}
                            >
                                <Close />
                            </IconButton>
                        </Col>
                    }
                >
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} >
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            <div style={{ backgroundColor: "#2e5fa3", borderRadius: 10, padding: 10, display: "flex", alignItems: "center", justifyContent: "center" }} >
                                <Description style={{ color: "white", fontSize: 22 }} />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ color: "white", fontSize: 18, fontWeight: 600 }} >
                                    Solicitud de Crédito
                                </span>

                                <small style={{ color: colors.blanco, fontSize: 13 }} >
                                    {cliente.nombres} {cliente.paterno} {cliente.materno}
                                </small>
                            </div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody style={{ minHeight: data.isDesktop ? "60vh" : "", height: data.isDesktop ? "60vh" : "", maxHeight: data.isDesktop ? "60vh" : "", overflowY: "scroll" }} >
                    <Row style={{ marginRight: 0, marginLeft: 0, width: "100%" }} >
                        <Col>
                            <Card >
                                <CardHeader>
                                    <Label style={{ color: colors.secundario, fontWeight: "bold" }} >
                                        <CalendarTodayOutlined /> Datos de la solicitud
                                    </Label>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col style={{ minWidth: data.isDesktop ? "33%" : "100%", width: data.isDesktop ? "33" : "100%", maxWidth: data.isDesktop ? "33%" : "100%", }} >
                                            <FormGroup className={`google-input ${cliente.fechaEntrevista ? "has-value" : ""}`}>
                                                <InputGroup>
                                                    <Input
                                                        type="date"
                                                        value={cliente.fechaEntrevista}
                                                        style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent", cursor: "pointer" }}
                                                        onChange={({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
                                                            setSolicitudCredito((prev: SolicitudCredito) => ({ ...prev, fechaCreacion: value }));
                                                        }}
                                                    />
                                                    <Label>
                                                        Fecha
                                                    </Label>
                                                </InputGroup>
                                                <span>
                                                    {FechaTool.convertirLetras(cliente.fechaEntrevista)}
                                                </span>
                                            </FormGroup>
                                        </Col>
                                        <Col style={{ minWidth: data.isDesktop ? "33%" : "100%", width: data.isDesktop ? "33" : "100%", maxWidth: data.isDesktop ? "33%" : "100%" }} >
                                            <FormControl fullWidth style={{ marginTop: 10 }} >
                                                <InputLabel
                                                    id="demo-simple-select-label"
                                                    sx={{
                                                        color: colors.secundario,
                                                        '&.MuiInputLabel-shrink': {
                                                            fontSize: '1.2rem',
                                                            color: colors.secundario
                                                        },
                                                    }}
                                                >
                                                    Tipo
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    style={{ borderRightColor: "transparent" }}
                                                    sx={SelectStyle.sx}
                                                    value={solicitudCredito.tipo.IdTipo.toString()}
                                                    onChange={({ target: { value } }: SelectChangeEvent) => {
                                                        setSolicitudCredito((prev: SolicitudCredito) => ({ ...prev, tipo: { ...prev.tipo, IdTipo: Number(value) } }));
                                                    }}
                                                >
                                                    <MenuItem value={0}> Selecciona una opcion </MenuItem>
                                                    {
                                                        arrayTipo.map((item: Value) => {
                                                            return <MenuItem value={item.Id}> {item.value} </MenuItem>
                                                        })
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Col>
                                        <Col style={{ minWidth: data.isDesktop ? "33%" : "100%", width: data.isDesktop ? "33" : "100%", maxWidth: data.isDesktop ? "33%" : "100%" }} >
                                            <FormControl fullWidth style={{ marginTop: 10 }} >
                                                <InputLabel
                                                    id="demo-simple-select-label"
                                                    sx={{
                                                        color: colors.secundario,
                                                        '&.MuiInputLabel-shrink': {
                                                            fontSize: '1.2rem',
                                                            color: colors.secundario
                                                        },
                                                    }}
                                                >
                                                    Estatus
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    style={{ borderRightColor: "transparent" }}
                                                    sx={SelectStyle.sx}
                                                    value={solicitudCredito.status.IdStatus.toString()}
                                                    onChange={({ target: { value } }: SelectChangeEvent) => {
                                                        setSolicitudCredito((prev: SolicitudCredito) => ({ ...prev, status: { ...prev.status, IdStatus: Number(value) } }));
                                                    }}
                                                >
                                                    <MenuItem value={0}> Selecciona una opcion </MenuItem>
                                                    {
                                                        arrayStatus.map((item: Value) => {
                                                            return <MenuItem value={item.Id}> {item.value} </MenuItem>
                                                        })
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0, width: "100%", marginTop: 20 }} >
                        <Col>
                            <Card>
                                <CardHeader>
                                    <Label style={{ color: colors.secundario, fontWeight: "bold" }} >
                                        <CreditCard /> Condiciones del credito
                                    </Label>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col style={{ minWidth: data.isDesktop ? "25%" : "100%", width: data.isDesktop ? "25" : "100%", maxWidth: data.isDesktop ? "25%" : "100%" }} >
                                            <FormControl fullWidth style={{ marginTop: 10 }} >
                                                <InputLabel
                                                    id="demo-simple-select-label"
                                                    sx={{
                                                        color: colors.secundario,
                                                        '&.MuiInputLabel-shrink': {
                                                            fontSize: '1.2rem',
                                                            color: colors.secundario
                                                        },
                                                    }}
                                                >
                                                    Monto
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    style={{ borderRightColor: "transparent" }}
                                                    sx={SelectStyle.sx}
                                                    value={solicitudCredito.monto.IdMonto.toString()}
                                                    onChange={({ target: { value } }: SelectChangeEvent) => {
                                                        setSolicitudCredito((prev: SolicitudCredito) => ({ ...prev, monto: { ...prev.monto, IdMonto: Number(value) } }));
                                                    }}
                                                >
                                                    <MenuItem value={0}> Selecciona una opcion </MenuItem>
                                                    {
                                                        arrayMonto.map((item: Value) => {
                                                            return <MenuItem value={item.Id}>$ {Numero.formatoComas(item.value)} </MenuItem>
                                                        })
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Col>
                                        <Col style={{ minWidth: data.isDesktop ? "25%" : "100%", width: data.isDesktop ? "25" : "100%", maxWidth: data.isDesktop ? "25%" : "100%" }} >
                                            <FormGroup className={`google-input ${false ? "move-left" : ""}`}>
                                                <InputGroup >
                                                    <InputGroupText style={{ borderColor: colors.secundario }} >
                                                        $
                                                    </InputGroupText>
                                                    <Input
                                                        type="text"
                                                        placeholder=" "
                                                        value={solicitudCredito.montoAprobado}
                                                        style={{ boxShadow: "none", borderColor: colors.secundario, borderRadius: 0, backgroundColor: "transparent" }}
                                                        onChange={({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {

                                                            value = Numero.formatoComas(Numero.soloNumeros(value, true));
                                                            setSolicitudCredito((prev: SolicitudCredito) => ({ ...prev, montoAprobado: value }));

                                                        }}
                                                    />
                                                    <Label style={{ marginLeft: 0 }} >Monto aprobado</Label>
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>
                                        <Col style={{ minWidth: data.isDesktop ? "25%" : "100%", width: data.isDesktop ? "25" : "100%", maxWidth: data.isDesktop ? "25%" : "100%" }} >
                                            <FormControl fullWidth style={{ marginTop: 10 }} >
                                                <InputLabel
                                                    id="demo-simple-select-label"
                                                    sx={{
                                                        color: colors.secundario,
                                                        '&.MuiInputLabel-shrink': {
                                                            fontSize: '1.2rem',
                                                            color: colors.secundario
                                                        },
                                                    }}
                                                >
                                                    Plazo
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    style={{ borderRightColor: "transparent" }}
                                                    sx={SelectStyle.sx}
                                                    value={solicitudCredito.plazo.IdPlazo.toString()}
                                                    onChange={({ target: { value } }: SelectChangeEvent) => {
                                                        setSolicitudCredito((prev: SolicitudCredito) => ({ ...prev, plazo: { ...prev.plazo, IdPlazo: Number(value) } }));
                                                    }}
                                                >
                                                    <MenuItem value={0}> Selecciona una opcion </MenuItem>
                                                    {
                                                        arrayPlazo.map((item: Value) => {
                                                            return <MenuItem value={item.Id}> {item.value} </MenuItem>
                                                        })
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Col>
                                        <Col style={{ minWidth: data.isDesktop ? "25%" : "100%", width: data.isDesktop ? "25" : "100%", maxWidth: data.isDesktop ? "25%" : "100%" }} >
                                            <FormControl fullWidth style={{ marginTop: 10 }} >
                                                <InputLabel
                                                    id="demo-simple-select-label"
                                                    sx={{
                                                        color: colors.secundario,
                                                        '&.MuiInputLabel-shrink': {
                                                            fontSize: '1.2rem',
                                                            color: colors.secundario
                                                        },
                                                    }}
                                                >
                                                    Forma de Pago
                                                </InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    style={{ borderRightColor: "transparent" }}
                                                    sx={SelectStyle.sx}
                                                    value={solicitudCredito.formaPago.IdFormaPago.toString()}
                                                    onChange={({ target: { value } }: SelectChangeEvent) => {
                                                        setSolicitudCredito((prev: SolicitudCredito) => ({ ...prev, formaPago: { ...prev.formaPago, IdFormaPago: Number(value) } }));
                                                    }}
                                                >
                                                    <MenuItem value={0}> Selecciona una opcion </MenuItem>
                                                    {
                                                        arrayFormaPago.map((item: Value) => {
                                                            return <MenuItem value={item.Id}> {item.value} </MenuItem>
                                                        })
                                                    }
                                                </Select>
                                            </FormControl>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    <Row style={{ marginRight: 0, marginLeft: 0, width: "100%", marginTop: 20 }} >
                        <Col>
                            <Card>
                                <CardHeader>
                                    <Label style={{ color: colors.secundario, fontWeight: "bold" }} >
                                        <Chat /> Observaciones
                                    </Label>
                                </CardHeader>
                                <CardBody>
                                    <Row>
                                        <Col>
                                            <FormControl fullWidth style={{ marginTop: 10, height: "80%" }} >
                                                <Input
                                                    className="no-focus"
                                                    style={{ height: 150, minHeight: 150, maxHeight: 150, boxShadow: "none", borderColor: colors.secundario }}
                                                    type="textarea"
                                                    value={solicitudCredito.observaciones}
                                                    onChange={({ target: { value } }: SelectChangeEvent) => {
                                                        if (value.length <= 500) {
                                                            setSolicitudCredito({ ...solicitudCredito, observaciones: value });
                                                        }
                                                    }}
                                                >
                                                </Input>
                                                <span> {solicitudCredito.observaciones.length}/500 </span>
                                            </FormControl>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    {
                        (solicitudCredito.usuario.IdUsuario !== 0 && !data.isDesktop) &&
                        <Row>
                            <Col style={{ textAlign: "left" }} >
                                <Row>
                                    <Label>
                                        Asesor: {solicitudCredito.usuario.nombre}
                                    </Label>
                                </Row>
                                <Row>
                                    <Label>
                                        Fecha y Hora: {FechaTool.convertirLetras(solicitudCredito.fechaModificacion).split(",")[0]} {FechaTool.formato(solicitudCredito.fechaModificacion)}, {TiempoTool.convertTimeTo12HourFormat(solicitudCredito.horaModificacion)}
                                    </Label>
                                </Row>
                            </Col>
                        </Row>
                    }
                </ModalBody>
                <ModalFooter>
                    <Row style={{ minWidth: "100%", width: "100%", maxWidth: "100%" }} >
                        {
                            (solicitudCredito.usuario.IdUsuario !== 0 && data.isDesktop) &&
                            <Col style={{ textAlign: "left" }} >
                                <Row>
                                    <Label>
                                        Asesor: {solicitudCredito.usuario.nombre}
                                    </Label>
                                </Row>
                                <Row>
                                    <Label>
                                        Fecha y Hora: {FechaTool.convertirLetras(solicitudCredito.fechaModificacion).split(",")[0]} {FechaTool.formato(solicitudCredito.fechaModificacion)}, {TiempoTool.convertTimeTo12HourFormat(solicitudCredito.horaModificacion)}
                                    </Label>
                                </Row>
                            </Col>
                        }

                        <Col style={{ textAlign: "right" }} >
                            {
                                solicitudCredito.IdSolicitudCredito !== 0 &&
                                <Button
                                    style={{ width: data.isDesktop ? 150 : "auto", backgroundColor: colors.blanco, borderColor: colors.rojo, fontWeight: "bold", boxShadow: "none", marginRight: 10, color: colors.rojo }}
                                    onClick={() => {
                                        setIsOpenModalEliniarSolicitud(true);
                                        setSolicitudCredito(solicitudCredito);
                                    }}
                                >
                                    <DeleteOutlineOutlined /> {data.isDesktop ? "Eliminar" : ""}
                                </Button>
                            }
                            <Button
                                style={{ width: data.isDesktop ? 150 : "auto", backgroundColor: colors.blanco, fontWeight: "bold", boxShadow: "none", marginRight: 10, color: colors.secundario, borderRadius: colors.secundario }}
                                onClick={() => setSolicitudCredito({ ...objectSolicitud, IdCliente: cliente.IdCliente })}
                            >
                                <PostAddOutlined /> {data.isDesktop ? "Nuevo" : ""}
                            </Button>
                            <Button
                                style={{ width: data.isDesktop ? 150 : "auto", backgroundColor: colors.secundario, fontWeight: "bold", boxShadow: "none" }}
                                onClick={() => solicitudCreditoGuardar()}
                            >
                                <SaveOutlined /> {data.isDesktop ? "Guardar" : ""}
                            </Button>
                        </Col>
                    </Row>

                </ModalFooter>
            </Modal>

            <Modal
                isOpen={isOpenModalEliniarSolicitud}
                centered
                fullscreen={data.isMovil}
                style={{ fontFamily: '"Fira Code", monospace', minWidth: "30%" }}
                onOpened={() => {
                    TiempoTool.sleep(30).then(() => {
                        setIsOpenModalEliniarSolicitud(false);
                        setSolicitudCredito(objectSolicitud);
                    });
                }}
            >
                <ModalHeader
                    style={{
                        backgroundColor: "#1f4b82",
                        padding: "12px 20px",
                        borderBottom: "none"
                    }}
                    close={
                        <Col style={{ textAlign: "right" }} >
                            <IconButton
                                style={{ color: colors.blanco }}
                                onClick={() => {
                                    setIsOpenModalEliniarSolicitud(false);
                                }}
                            >
                                <Close />
                            </IconButton>
                        </Col>
                    }
                >
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} >
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            <div style={{ backgroundColor: "#2e5fa3", borderRadius: 10, padding: 10, display: "flex", alignItems: "center", justifyContent: "center" }} >
                                <WarningAmberOutlined style={{ color: "white", fontSize: 22 }} />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ color: "white", fontSize: 18, fontWeight: 600 }} >
                                    ¡Atencion!
                                </span>
                            </div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <center>
                        <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10 }} >
                            <Col  >
                                <div style={{ height: 70, width: 70, backgroundColor: "#FCEDED", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center" }} >
                                    <AutoDeleteOutlined style={{ height: 50, width: 50, color: "#D83F37" }} />
                                </div>
                            </Col>
                        </Row>
                        <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10, fontSize: 16 }} >
                            <Col style={{ textAlign: "center" }} >
                                <Label style={{ fontWeight: "bold" }} >
                                    Eliminacion de Solicitud de Credito
                                </Label>
                            </Col>
                        </Row>
                        <Row style={{ marginRight: 0, marginLeft: 0, marginTop: 10, fontSize: 14 }} >
                            <Col style={{ textAlign: "center" }} >
                                <p>
                                    Una vez eliminada la solicitud de credito
                                    no se podran recuperar los datos
                                </p>
                            </Col>
                        </Row>
                    </center>
                </ModalBody>
                <ModalFooter>
                    <Button
                        style={{ width: "auto", backgroundColor: colors.blanco, borderColor: colors.rojo, fontWeight: "bold", boxShadow: "none", marginRight: 10, color: colors.rojo }}
                        onClick={() => { solicitudCreditoEliminar(); }}
                    >
                        <DeleteOutlineOutlined />  Eliminar
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal
                isOpen={isOpenModalSolicitudError}
                centered
                fullscreen={data.isMovil}
                style={{ fontFamily: '"Fira Code", monospace', minWidth: "60%" }}
                onOpened={() => { }}
            >
                <ModalHeader
                    style={{ backgroundColor: colors.secundario }}
                    close={
                        <Col style={{ textAlign: "right" }} >
                            <IconButton
                                style={{ backgroundColor: colors.secundario, color: colors.blanco }}
                                onClick={() => setIsOpenModalSolicitudError(false)}
                            >
                                <Close />
                            </IconButton>
                        </Col>
                    }
                >
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }} >
                        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                            <div style={{ backgroundColor: "#2e5fa3", borderRadius: 10, padding: 10, display: "flex", alignItems: "center", justifyContent: "center" }} >
                                <WarningAmberOutlined style={{ color: "white", fontSize: 22 }} />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <span style={{ color: "white", fontSize: 18, fontWeight: 600 }} >
                                    Atencion
                                </span>
                            </div>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody style={{ minHeight: data.isDesktop ? "60vh" : "", height: data.isDesktop ? "60vh" : "", maxHeight: data.isDesktop ? "60vh" : "", overflowY: "scroll" }} >
                    <Row>
                        <Col style={{ minWidth: "100%", width: "100%", maxWidth: "100%", backgroundColor: "transparent" }} >
                            <Row style={{ width: "100%", marginRight: 0, marginLeft: 0 }} >
                                <Label style={{ color: colors.rojo, fontWeight: "bold", fontSize: 18 }} >
                                    <ErrorOutlined style={{ marginRight: 10 }} />
                                    No se guardo la solicitud de credito
                                    <br />
                                    <span style={{ fontSize: 16, fontWeight: "normal", marginLeft: 30 }} >Verifica la siguiente informacion antes de continuar</span>
                                </Label>
                            </Row>
                            <Row style={{ width: "100%", marginRight: 0, marginLeft: 0 }} >
                                <Block height={"1px"} backgroundColor={colors.secundario} />
                            </Row>
                            {
                                indexDatoFaltanteSolicitud.find((item) => item.index === "IdTipo")?.value &&
                                <>
                                    <Row style={{ width: "100%", marginRight: 0, marginLeft: 0, marginTop: 20 }} >
                                        <Col style={{ maxWidth: "10%" }} >
                                            <div style={{ height: 50, width: 50, borderRadius: "50%", backgroundColor: "#E6F0FB", display: "flex", alignItems: "center", justifyContent: "center" }} >
                                                <Groups2Outlined style={{ height: 40, width: 40, color: colors.secundario }} />
                                            </div>
                                        </Col>
                                        <Col style={{ maxWidth: "90%" }} >
                                            <Label style={{ color: colors.negro, fontWeight: "bold", fontSize: 16 }} >
                                                Tipo de Solicitud de Credito
                                                <br />
                                                <span style={{ fontSize: 14, fontWeight: "normal" }} > Verifique que este seleccionado el tipo de solicitud </span>
                                            </Label>
                                        </Col>
                                    </Row>
                                    <DropdownItem divider />
                                </>
                            }
                            {
                                indexDatoFaltanteSolicitud.find((item) => item.index === "IdStatus")?.value &&
                                <>
                                    <Row style={{ width: "100%", marginRight: 0, marginLeft: 0, marginTop: 20 }} >
                                        <Col style={{ maxWidth: "10%" }} >
                                            <div style={{ height: 50, width: 50, borderRadius: "50%", backgroundColor: "#E6F0FB", display: "flex", alignItems: "center", justifyContent: "center" }} >
                                                <RecommendOutlined style={{ height: 40, width: 40, color: colors.secundario }} />
                                            </div>
                                        </Col>
                                        <Col style={{ maxWidth: "90%" }} >
                                            <Label style={{ color: colors.negro, fontWeight: "bold", fontSize: 16 }} >
                                                Estatus de la Solicitud de Credito
                                                <br />
                                                <span style={{ fontSize: 14, fontWeight: "normal" }} > Verifique que este seleccionado el estatus de la solicitud </span>
                                            </Label>
                                        </Col>
                                    </Row>
                                    <DropdownItem divider />
                                </>
                            }
                            {
                                indexDatoFaltanteSolicitud.find((item) => item.index === "IdMonto")?.value &&
                                <>
                                    <Row style={{ width: "100%", marginRight: 0, marginLeft: 0, marginTop: 20 }} >
                                        <Col style={{ maxWidth: "10%" }} >
                                            <div style={{ height: 50, width: 50, borderRadius: "50%", backgroundColor: "#E6F0FB", display: "flex", alignItems: "center", justifyContent: "center" }} >
                                                <AttachMoneyOutlined style={{ height: 40, width: 40, color: colors.secundario }} />
                                            </div>
                                        </Col>
                                        <Col style={{ maxWidth: "90%" }} >
                                            <Label style={{ color: colors.negro, fontWeight: "bold", fontSize: 16 }} >
                                                Monto Solicitado
                                                <br />
                                                <span style={{ fontSize: 14, fontWeight: "normal" }} > Verifique que este seleccionado el monto solicitado </span>
                                            </Label>
                                        </Col>
                                    </Row>
                                    <DropdownItem divider />
                                </>
                            }
                            {
                                indexDatoFaltanteSolicitud.find((item) => item.index === "IdPlazo")?.value &&
                                <>
                                    <Row style={{ width: "100%", marginRight: 0, marginLeft: 0, marginTop: 20 }} >
                                        <Col style={{ maxWidth: "10%" }} >
                                            <div style={{ height: 50, width: 50, borderRadius: "50%", backgroundColor: "#E6F0FB", display: "flex", alignItems: "center", justifyContent: "center" }} >
                                                <CalendarTodayOutlined style={{ height: 40, width: 40, color: colors.secundario }} />
                                            </div>
                                        </Col>
                                        <Col style={{ maxWidth: "90%" }} >
                                            <Label style={{ color: colors.negro, fontWeight: "bold", fontSize: 16 }} >
                                                Plazo del Credito
                                                <br />
                                                <span style={{ fontSize: 14, fontWeight: "normal" }} > Verifique que este seleccionado el plazo del credito </span>
                                            </Label>
                                        </Col>
                                    </Row>
                                    <DropdownItem divider />
                                </>
                            }
                            {
                                indexDatoFaltanteSolicitud.find((item) => item.index === "IdFormaPago")?.value &&
                                <>
                                    <Row style={{ width: "100%", marginRight: 0, marginLeft: 0, marginTop: 20 }} >
                                        <Col style={{ maxWidth: "10%" }} >
                                            <div style={{ height: 50, width: 50, borderRadius: "50%", backgroundColor: "#E6F0FB", display: "flex", alignItems: "center", justifyContent: "center" }} >
                                                <PaymentOutlined style={{ height: 40, width: 40, color: colors.secundario }} />
                                            </div>
                                        </Col>
                                        <Col style={{ maxWidth: "90%" }} >
                                            <Label style={{ color: colors.negro, fontWeight: "bold", fontSize: 16 }} >
                                                Forma de Pago
                                                <br />
                                                <span style={{ fontSize: 14, fontWeight: "normal" }} > Verifique que este seleccionado la forma de pago </span>
                                            </Label>
                                        </Col>
                                    </Row>
                                    <DropdownItem divider />
                                </>
                            }
                        </Col>

                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button
                        style={{ width: 150, backgroundColor: colors.secundario, fontWeight: "bold", boxShadow: "none" }}
                        onClick={() => setIsOpenModalSolicitudError(false)}
                    >
                        <CloseFullscreen /> Entendido
                    </Button>
                </ModalFooter>
            </Modal>

            <Modal
                isOpen={isOpenModelPDF}
                fullscreen
                style={{ fontFamily: '"Fira Code", monospace', }}
                onOpened={() => { }}
            >
                <ModalHeader
                    style={{ backgroundColor: "#282828", padding: 5 }}
                    close={
                        <Col style={{ textAlign: "right" }} >
                            <IconButton
                                style={{ color: colors.blanco, marginRight: 15 }}
                                onClick={async () => {

                                    const blob = await pdf(
                                        <SolicitudCreditoPdf
                                            cliente={cliente}
                                            solicitudCredito={solicitudCredito}
                                            operacionesMontos={operacionesMontos}
                                            operacionesNumeros={operacionesNumeros}
                                            operacionesFrecuencias={operacionesFrecuencias}
                                        />
                                    ).toBlob();

                                    const url = URL.createObjectURL(blob);

                                    const link = document.createElement("a");
                                    link.href = url;
                                    link.download = `Solicitud Credito de ${cliente.nombres} ${cliente.paterno} ${cliente.materno}.pdf`;
                                    link.click();

                                }}
                            >
                                <DownloadOutlined />
                            </IconButton>
                            <IconButton
                                style={{ color: colors.blanco }}
                                onClick={() => {
                                    setIsOpenModalPDF(false);
                                }}
                            >
                                <Close />
                            </IconButton>
                        </Col>
                    }
                >

                </ModalHeader>
                <ModalBody style={{ padding: 0, overflowY: "hidden" }} >
                    <PDFViewer width="100%" height="100%"  >
                        <SolicitudCreditoPdf
                            cliente={cliente}
                            solicitudCredito={solicitudCredito}
                            operacionesMontos={operacionesMontos}
                            operacionesNumeros={operacionesNumeros}
                            operacionesFrecuencias={operacionesFrecuencias}
                        />
                    </PDFViewer>
                </ModalBody>
                {/* <ModalFooter>

                </ModalFooter> */}
            </Modal>

        </>
    );


};


export default ClienteAgregar;